// Copyright (c) Tangible It, Mexico. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import ReactTooltip from "react-tooltip";

import axios from "axios";

import Header from "../../components/Header/Header";

import "./Attendance.css";

import Controls from "../../components/Controls";
import {
  NotesIcon,
  SurveyIcon,
  AcceptIcon,
  ShiftActivityIcon,
  CloseIcon,
  AttendeeIcon,
  ThumbtackIcon,
  IndentIcon,
  NumberListIcon,
  TranscriptIcon,
  ContactCardIcon,
} from "@fluentui/react-icons-northstar";

import {
  Text,
  Card,
  Image,
  Table,
  Button,
  MenuButton,
  Label,
  Checkbox,
  ItemLayout,
  Avatar,
  Flex,
  Input,
  Loader,
  Dialog,
  Tooltip,
  Popup,
} from "@fluentui/react-northstar";

import { withTranslation } from "react-i18next";

import Imgart from "../../Assets/images/subjects/art.png";
import Imgcivil from "../../Assets/images/subjects/civil.png";
import Imghistory from "../../Assets/images/subjects/history.png";
import ImgnaturalScience from "../../Assets/images/subjects/natural-science.png";
import Imgphilosophy from "../../Assets/images/subjects/philosophy.png";
import ImgscienceExact from "../../Assets/images/subjects/science-exact.png";
import Imgtech from "../../Assets/images/subjects/tech.png";
import Imgother from "../../Assets/images/subjects/other.png";
import DateSelection from "../../Assets/images/svg/DateSelection.svg";
import LessonSelection from "../../Assets/images/svg/LessonSelection.svg";
import moment from "moment";
import { toast } from "react-toastify";
import { Subscription } from "../../components/Subscription/Subscription";
import AvailbleClass from "./AvailbleClass";
import DownloadIcon from "./DownloadIcon";
import StudentProgress from "../../components/studentProgress";
import AttendanceSkeleton from "./AttendanceSkeleton";
import { HomeOutlined } from "@mui/icons-material";
import {
  isUndoIntent,
  isRedoIntent,
  getLanguageCode,
} from "../../utils/voiceIntents";

const url = process.env.REACT_APP_EP_URL;
const v = new Date(new Date().setHours(0, 0, 0, 0));
let headers;
class Attendance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lessions: [],
      records: [],
      selectedLesson: null,
      showLesson: [],
      showRecords: [],
      showRecordsAnalytics: {
        virtual: 0,
        total: 0,
        present: 0,
        absent: 0,
        late: 0,
        justification: 0,
      },
      showTopic: false,
      showNote: false,
      selectedDate: v.toISOString(),
      selectedClass: null,
      selectedTeacher: null,
      response: {},
      checkAll: false,
      checkedRecords: [],
      checkedRecordsMode: [],
      onLine: null,
      load: false,
      dialog: false,
      isExpire: false,
      accDlg: false,
      selectedLessonType: false,
      isCompactMode: false,
      isSmall: false,
      isDateSelected: false,
      isSubscribed: false,
      isMobileView: false,
      isOpen: false,
      getSelectedData: v,
      selectedDay: null,
    };
    // Simple in-memory undo stack for last actions (attendance, notes)
    this.undoStack = [];
    this.maxUndoItems = 100;
    // Redo stack to support reapplying last undone actions
    this.redoStack = [];
    // Fallback storage for last recorded action and guard flag
    this.lastAction = null;
    this.isPerformingUndo = false;
    // Prevent duplicate undo pushes when we programmatically click a lesson card
    this.isProgrammaticLessonClick = false;
  }

  //choose the screen size
  handleResize = (val) => {
    if (window.innerWidth < 375) {
      this.setState({ isSmall: true });
    } else {
      this.setState({ isSmall: false });
    }
    if (val === "TOPIC") {
      if (window.innerWidth < 1000) {
        this.setState({
          showNote: false,
        });
        this.setState({ showTopic: !this.state.showTopic });
      } else {
        this.setState({ showTopic: !this.state.showTopic });
        this.state.showNote && this.setState({ showNote: true });
      }
    } else {
      if (window.innerWidth < 1000) {
        this.setState({
          showTopic: false,
        });
        this.setState({ showNote: !this.state.showNote });
      } else {
        this.setState({ showNote: !this.state.showNote });
        this.state.showTopic && this.setState({ showTopic: true });
      }
    }
    if (window.innerWidth <= 767) {
      this.setState({ isMobileView: true });
    } else {
      this.setState({ isMobileView: false });
    }
  };

  async componentDidMount() {
    if (location.pathname?.includes("attendance")) {
      this.props.setSelectedTab("attendance");
    }
    // Rehydrate last undoable action from session storage to survive remounts
    try {
      const saved = sessionStorage.getItem("ACV_ATTENDANCE_LAST_ACTION");
      if (saved) {
        this.lastAction = JSON.parse(saved);
      }
    } catch (e) {
      // ignore
    }
    const wiseDay = this.state?.getSelectedData?.getDay() || v.getDay();
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    this.setState({ selectedDay: days[wiseDay] });

    headers = {
      Authorization: "Bearer " + this.props.user.accessToken,
    };
    try {
      window.ACV_CURRENT_VOICE_HANDLER = this.handleVoiceCommand.bind(this);
      window.ACV_CURRENT_PAGE_KEY = "attendance";
    } catch (e) {}

    const subscription = JSON.parse(localStorage.getItem("subscription"));
    if (subscription && subscription?.attendance) {
      this.setState({ isSubscribed: true, load: false });
    } else {
      this.setState({ isSubscribed: false, load: false });
    }
    if (this.props.user?.dbData?.dayRemaining <= 2) {
      if (this.props.user?.dbData?.ExpirationDate) {
        if (this.props.user?.dbData?.dayRemaining <= 0) {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: false,
            isExpire: true,
          });
        } else {
          this.setState({
            ExpirationDate: this.props.user?.dbData?.ExpirationDate,
            dialog: true,
            isExpire: false,
          });
        }
      }
    }

    // this.getAllLessons();
    this.fetchLessons();

    if (navigator.onLine) {
      this.setState({ onLine: navigator.onLine });
    }

    window.addEventListener("offline", (e) => {
      console.log(e, "you're offline");
      this.setState({ onLine: navigator.onLine });
    });
  }

  componentWillUnmount() {
    try {
      if (window.ACV_CURRENT_VOICE_HANDLER) {
        delete window.ACV_CURRENT_VOICE_HANDLER;
      }
      if (window.ACV_CURRENT_PAGE_KEY) {
        delete window.ACV_CURRENT_PAGE_KEY;
      }
    } catch (e) {}
  }

  //React lifecycle method that gets called after a component's state or props updates
  //Learn more: https://reactjs.org/docs/react-component.html#componentdidupdate
  componentDidUpdate = async (prevProps, prevState) => {
    if (
      this.props.user.slug === "?slug=acvpreprod" ||
      this.props.user.slug === "?slug=acvapp"
    ) {
      if (prevState.selectedDate !== this.state.selectedDate) {
        const wiseDay = this.state?.getSelectedData?.getDay();
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        this.setState({ selectedDay: days[wiseDay] });
      }
    }

    //Check to see if a Graph access token is now in state AND that it didn't exist previously
    if (prevProps.user.slug !== this.props.user.slug) {
      this.fetchLessons();
    }
  };

  // Compute a stable DOM key for a lesson card.
  // Prefer LessonId; if missing, fall back to a composite of date/time/class.
  getLessonDomKey = (lsn) => {
    if (!lsn) return "";
    const id = lsn?.LessonId;
    if (id !== undefined && id !== null && id !== "") {
      return String(id);
    }
    const parts = [
      lsn?.LessonDate || "",
      lsn?.StartTime || "",
      lsn?.EndTime || "",
      lsn?.ClassName || lsn?.Title || "",
    ];
    return parts.join("|");
  };

  // Create a compact snapshot of lesson identification fields for robust undo/redo fallback
  buildLessonSnapshot = (lsn) => {
    if (!lsn) return null;
    return {
      LessonId: lsn?.LessonId ?? null,
      LessonDate: lsn?.LessonDate ?? null,
      StartTime: lsn?.StartTime ?? null,
      EndTime: lsn?.EndTime ?? null,
      ClassName: lsn?.ClassName ?? null,
      Title: lsn?.Title ?? null,
    };
  };

  // Find lesson index in a list by normalized LessonId, falling back to composite key
  findLessonIndex = (targetLesson, list) => {
    if (!targetLesson || !Array.isArray(list)) return -1;
    const id = targetLesson?.LessonId;
    // Only attempt ID-based match when ID is defined and non-empty
    let idx = -1;
    if (id !== undefined && id !== null && id !== "") {
      idx = list.findIndex((l) => String(l?.LessonId) === String(id));
    }
    if (idx === -1) {
      const key = this.getLessonDomKey(targetLesson);
      idx = list.findIndex((l) => this.getLessonDomKey(l) === key);
    }
    return idx;
  };

  getAllLessons = () => {
    axios
      .get(`${url}/api/lession/get-lessions${this.props.user.slug}`, {
        headers: headers,
      })
      .then((res) => {
        const lessions = res.data;
        this.setState({ lessions });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  fetchLessons = (note) => {
    if (!note) {
      this.setState({ selectedLesson: null, showRecords: [] });
    }
    const lessonData = JSON.parse(localStorage.getItem("selectedLession"));

    if (lessonData) {
      if (this.state.selectedDate === lessonData.LessonDate) {
        this.setState(
          {
            selectedLesson: lessonData,
          },
          () => this.fetchRecordsByLesson()
        );
      }
    }

    if (document.querySelector(".h-cls")) {
      document.querySelector(".h-cls").classList.remove("h-cls");
    }
    const selectedDate = this.state.selectedDate;
    const selectedClass = this.state.selectedClass;
    const selectedTeacher = this.state.selectedTeacher;
    axios
      .post(
        `${url}/api/lession/get-lession-by-teacher${this.props.user.slug}`,
        {
          ClassName: selectedClass,
          TeacherEmailAlias: selectedTeacher,
          LessonDate: selectedDate,
        },
        { headers: headers }
      )
      .then((res) => {
        const showLesson = res.data.result.sort((a, b) =>
          a.StartTime.toLowerCase() > b.StartTime.toLowerCase() ? 1 : -1
        );
        this.setState({ showLesson });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  fetchRecordsByLesson = () => {
    // Prefer unique LessonId when available to avoid ambiguity with duplicate titles
    const lessonKey =
      this.state.selectedLesson?.LessonId || this.state.selectedLesson?.Title;
    axios
      .get(
        `${url}/api/record/get-record-by-lession/${lessonKey}${this.props.user.slug}`,
        { headers: headers }
      )
      .then((res) => {
        const showRecords = res.data.result;
        if (res.data.result && res.data.result.length) {
          const selectedLessonType = res.data.result[0].ClassType;
          this.setState({ showRecords, load: false, selectedLessonType });
          try {
            window.localStorage.setItem(
              "acv_last_attendance_records",
              JSON.stringify(showRecords || [])
            );
          } catch (e) {
            /* ignore storage errors */
          }
        } else {
          axios
            .get(
              `${url}/api/lession/get-lesson-class-type/${lessonKey}${this.props.user.slug}`,
              { headers: headers }
            )
            .then((res) => {
              const selectedLessonType = res.data?.result?.ClassType;
              this.setState({ showRecords, load: false, selectedLessonType });
              try {
                window.localStorage.setItem(
                  "acv_last_attendance_records",
                  JSON.stringify(showRecords || [])
                );
              } catch (e) {
                /* ignore storage errors */
              }
            })
            .catch((err) => {
              toast.error(err?.response?.data?.message);
              console.log(err, err.response);
              if (err.response?.status === 401) {
                this.setState({ accDlg: true });
              }
            });
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err, err.response);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  lessonTopicHandler = () => {
    const lessonTitle = this.state.selectedLesson?.Title
      ? this.state.selectedLesson.Title
      : this.state.selectedLesson?.LessonId;
    axios
      .put(
        `${url}/api/lession/update-class-topic/${lessonTitle}${this.props.user.slug}`,
        {
          Tema: document.getElementById("textLessonTopic").value,
        },
        { headers: headers }
      )
      .then((res) => {
        // console.log(res);
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showTopic: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  lessonNoteHandler = () => {
    const lessonTitle = this.state.selectedLesson?.Title
      ? this.state.selectedLesson.Title
      : this.state.selectedLesson?.LessonId;
    axios
      .put(
        `${url}/api/lession/update-class-note/${lessonTitle}${this.props.user.slug}`,
        {
          Tarea: document.getElementById("textLessonNote").value,
        },
        { headers: headers }
      )
      .then((res) => {
        this.fetchLessons("note");
        const status = res.data.status;
        if (status === "Success") {
          this.setState({ showNote: false });
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  studentNoteHandler = (email, lsn, note) => {
    // Capture previous note for undo before updating
    try {
      const prevRecord = this.state.showRecords.find(
        (stud) => stud.StudentEmailId === email && stud.LessonId === lsn
      );
      const prevNote = prevRecord ? prevRecord.Notes || "" : "";
      if (!this.isPerformingUndo) {
        this._pushUndoAction({
          type: "note",
          email,
          lessonId: lsn,
          previous: prevNote,
          next: note === null ? "" : note,
        });
      }
    } catch (e) {
      // Ignore capture errors
      console.log("Undo capture (note) skipped:", e?.message);
    }
    return axios
      .put(
        `${url}/api/record/update-student-note${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Notes: note === null ? "" : note,
        },
        { headers: headers }
      )
      .then((res) => {
        const status = res.data.status;
        if (status === "Success") {
          const foundRecord = this.state.showRecords.find((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          const foundIndex = this.state.showRecords.findIndex((stud) => {
            return stud.StudentEmailId === email
              ? stud.LessonId === lsn
                ? stud.LessonId === lsn
                : null
              : null;
          });
          let recordData = [...this.state.showRecords];
          foundRecord.Notes = note;
          recordData[foundIndex] = foundRecord;
          this.setState({ showRecords: recordData });
          // Safety net: record last note action snapshot only when not performing undo/redo
          if (!this.isPerformingUndo) {
            try {
              const fallbackEntry = {
                timestamp: Date.now(),
                type: "note",
                email,
                lessonId: lsn,
                previous: prevRecord ? prevRecord.Notes || "" : "",
                next: note === null ? "" : note,
              };
              this.lastAction = fallbackEntry;
              try {
                sessionStorage.setItem(
                  "ACV_ATTENDANCE_LAST_ACTION",
                  JSON.stringify(fallbackEntry)
                );
              } catch (e) {}
            } catch (e) {}
          } else {
          }
          return { success: true, message: "Note updated successfully" };
        }
        return { success: false, message: "Failed to update note" };
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
        return {
          success: false,
          message: err?.response?.data?.message || "Error updating note",
        };
      });
  };

  checkedRecordsHandler = (attendance, takenBy) => {
    let chkRecords = [...this.state.checkedRecords];
    // Capture previous attendance for each selected student before bulk update
    try {
      if (!this.isPerformingUndo && chkRecords && chkRecords.length) {
        chkRecords.forEach((student) => {
          try {
            const prevRecord = this.state.showRecords.find(
              (stud) =>
                stud.StudentEmailId === student.StudentEmailId &&
                stud.LessonId === student.LessonId
            );
            const prevAttendance = prevRecord ? prevRecord.Attendance : null;
            this._pushUndoAction({
              type: "attendance",
              email: student.StudentEmailId,
              lessonId: student.LessonId,
              previous: prevAttendance,
              next: attendance,
            });
          } catch (e) {
            console.log(
              "[UNDO] Bulk capture failed for:",
              student?.StudentEmailId,
              e?.message
            );
          }
        });
      }
    } catch (e) {
      console.log("Undo capture (bulk attendance) skipped:", e?.message);
    }
    chkRecords = chkRecords.map((student) => {
      return {
        Attendance: attendance,
        AttendanceTakenBy: takenBy,
        ClassId: student.ClassId,
        ClassName: student.ClassName,
        EndTime: student.EndTime,
        LessonDate: student.LessonDate,
        LessonId: student.LessonId,
        Notes: student.Notes,
        StartTime: student.StartTime,
        StudentEmailId: student.StudentEmailId,
        StudentName: student.StudentName,
      };
    });
    axios
      .post(
        `${url}/api/record/take-attendence${this.props.user.slug}`,
        chkRecords,
        {
          headers: headers,
        }
      )
      .then((res) => {
        this.setState({ checkedRecords: res.data.result });
        this.fetchRecordsByLesson();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  checkedRecordsModeHandler = (body) => {
    axios
      .post(
        `${url}/api/student/update-student-class-mode${this.props.user.slug}`,
        body,
        {
          headers: headers,
        }
      )
      .then((res) => {
        // this.setState({ checkedRecords: res.data.result });
        // this.fetchRecordsByLesson();
        this.analyticsHandler();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };
  takeAttendance = (email, lsn, attendance, takenBy) => {
    // Don't proceed if email is not provided
    if (!email) {
      console.log("Attendance update skipped: No email provided");
      return;
    }

    // Capture previous attendance for undo before changing state
    try {
      const prevRecord = this.state.showRecords.find(
        (stud) => stud.StudentEmailId === email && stud.LessonId === lsn
      );
      const prevAttendance = prevRecord ? prevRecord.Attendance : null;
      if (!this.isPerformingUndo) {
        this._pushUndoAction({
          type: "attendance",
          email,
          lessonId: lsn,
          previous: prevAttendance,
          next: attendance,
        });
      }
    } catch (e) {
      // Ignore capture errors
      console.log("Undo capture (attendance) skipped:", e?.message);
    }

    this.changeRecordState(email, lsn, attendance, takenBy);
    axios
      .put(
        `${url}/api/record/update-student-attendance${this.props.user.slug}`,
        {
          StudentEmailId: email,
          LessonId: lsn,
          Attendance: attendance,
          AttendanceTakenBy: this.props.user.username,
        },
        { headers: headers }
      )
      .then((res) => {
        const response = res.data;
        if (response.status !== "Success") {
          // console.log("Attendance Updation Failed!");
        }
      })
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  changeRecordState = (email, lsn, attendance, takenBy) => {
    const foundRecord = this.state.showRecords.find((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    const foundIndex = this.state.showRecords.findIndex((stud) => {
      return stud.StudentEmailId === email
        ? stud.LessonId === lsn
          ? stud.LessonId === lsn
          : null
        : null;
    });
    let recordData = [...this.state.showRecords];
    const prevAttendanceSnapshot = foundRecord ? foundRecord.Attendance : null;
    foundRecord.Attendance = attendance;
    foundRecord.AttendanceTakenBy = this.props.user.username;
    recordData[foundIndex] = foundRecord;
    this.setState({ showRecords: recordData });
    // As a safety net, record the last action snapshot only when not performing undo/redo
    if (!this.isPerformingUndo) {
      try {
        const fallbackEntry = {
          timestamp: Date.now(),
          type: "attendance",
          email,
          lessonId: lsn,
          previous: prevAttendanceSnapshot,
          next: attendance,
        };
        this.lastAction = fallbackEntry;
        try {
          sessionStorage.setItem(
            "ACV_ATTENDANCE_LAST_ACTION",
            JSON.stringify(fallbackEntry)
          );
        } catch (e) {}
      } catch (e) {
        console.log("[UNDO] Failed to set fallback snapshot:", e?.message);
      }
    } else {
      console.log("[UNDO] Skipping fallback snapshot during undo/redo");
    }
  };

  analyticsHandler = () => {
    let analytics = {
      virtual: 0,
      total: 0,
      present: 0,
      absent: 0,
      late: 0,
      justification: 0,
    };
    this.state.showRecords.map((student) => {
      analytics.total++;
      if (student.ClassType === "Virtual") {
        analytics.virtual++;
      }
      if (student.Attendance === "Presente") {
        analytics.present++;
      } else if (student.Attendance === "Ausente") {
        analytics.absent++;
      } else if (student.Attendance === "Retardo") {
        analytics.late++;
      } else if (
        student.Attendance === "Sickness" ||
        student.Attendance === "Family emergency" ||
        student.Attendance === "Not feel well"
      ) {
        analytics.absent++;
        analytics.justification++;
      }
      return null;
    });
    this.setState({ showRecordsAnalytics: analytics });
  };

  pinnedHandler = (isVirtual, email) => {
    axios
      .put(
        `${url}/api/student/update-student-present-mode${this.props.user.slug}`,
        {
          isVirtual: isVirtual,
          StudentEmailID: [email],
        },
        { headers: headers }
      )
      .then(() => this.analyticsHandler())
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          this.setState({ accDlg: true });
        }
      });
  };

  onCompactModeHandler = () => {
    const { isCompactMode } = this.state;
    this.setState({
      ...this.state,
      isCompactMode: !isCompactMode,
    });
    console.log("compact mode changed", !isCompactMode);
  };

  handleClose = () => {
    props.setIsMobileViewFiltersOpen(false);
  };

  openPanel = () => {
    this.setState({ isOpen: true });
  };

  dismissPanel = () => {
    this.setState({ isOpen: false });
  };

  handleIconClick = (student) => {
    let data = [...this.state.showRecords];
    const currentClassType = data[data.indexOf(student)].ClassType;
    const newClassType = currentClassType === "Virtual" ? "Hybrid" : "Virtual";

    data[data.indexOf(student)].ClassType = newClassType;
    this.setState({ showRecords: data });
    this.checkedRecordsModeHandler({
      lessonId: student.LessonId,
      studentId: [student.StudentEmailId],
      mode: newClassType,
    });
  };

  handleCheckMultipleRecords = () => {
    let showRecords = this.state.showRecords.slice();
    let listRecords = [];

    const checked =
      this.state.showRecords.length === this.state.showRecordsAnalytics.virtual;
    const newClassType = checked ? "Hybrid" : "Virtual";

    showRecords = showRecords.map((student) => {
      student.ClassType = newClassType;
      listRecords.push(student.StudentEmailId);
      return student;
    });

    this.setState({ showRecords });

    this.checkedRecordsModeHandler({
      lessonId: this.state.selectedLesson.Title
        ? this.state.selectedLesson.Title
        : this.state.selectedLesson?.LessonId,
      studentId: listRecords,
      mode: newClassType,
    });
  };

  // Helper method to handle single note command
  handleSingleNoteCommand = async (command) => {
    const { type, studentName, noteText } = command;

    // Debug logging to track note text
    console.log("🔍 [handleSingleNoteCommand] Command received:", {
      type,
      studentName,
      noteText,
      fullCommand: command,
    });

    if (!studentName) {
      return {
        success: false,
        message: "Please specify a student name for the note",
      };
    }

    // Find the student using the same logic as attendance commands
    const updatedStudents = [...this.state.showRecords];
    let target = null;

    // Try to find student by index first (e.g., "student 3")
    const extractIndexFromName = (nameLike) => {
      if (!nameLike) return null;
      const lower = String(nameLike).toLowerCase();
      const wordToNum = {
        one: 1,
        two: 2,
        three: 3,
        four: 4,
        five: 5,
        six: 6,
        seven: 7,
        eight: 8,
        nine: 9,
        ten: 10,
        first: 1,
        second: 2,
        third: 3,
        fourth: 4,
        fifth: 5,
        sixth: 6,
        seventh: 7,
        eighth: 8,
        ninth: 9,
        tenth: 10,
      };
      const digitMatch = lower.match(/\b(\d{1,2})\b/);
      if (digitMatch) return parseInt(digitMatch[1], 10);
      for (const [word, num] of Object.entries(wordToNum)) {
        if (lower.includes(word)) return num;
      }
      return null;
    };

    const getStudentByIndexFromName = (nameLike) => {
      const idx = extractIndexFromName(nameLike);
      if (!idx || idx < 1 || idx > updatedStudents.length) return null;
      return updatedStudents[idx - 1];
    };

    const normalizeForCompare = (str) => {
      if (!str) return "";
      let s = (" " + String(str).toLowerCase() + " ")
        .replace(/ student\s+/g, " ")
        .replace(/ one(?=\b)/g, " 1")
        .replace(/ two(?=\b)/g, " 2")
        .replace(/ three(?=\b)/g, " 3")
        .replace(/ four(?=\b)/g, " 4")
        .replace(/ five(?=\b)/g, " 5")
        .replace(/ six(?=\b)/g, " 6")
        .replace(/ seven(?=\b)/g, " 7")
        .replace(/ eight(?=\b)/g, " 8")
        .replace(/ nine(?=\b)/g, " 9")
        .replace(/ ten(?=\b)/g, " 10");
      return s.replace(/[^a-z0-9]/g, "");
    };

    const findStudentByLooseName = (needle) => {
      if (!needle || needle.trim() === "") return null;
      const target = normalizeForCompare(needle);

      // First try exact match
      const exactMatch = updatedStudents.find((student) => {
        return student.StudentName.toLowerCase() === needle.toLowerCase();
      });

      if (exactMatch) {
        return exactMatch;
      }

      // Then try loose match
      return updatedStudents.find((student) => {
        const n1 = normalizeForCompare(student.StudentName);
        const n2 = normalizeForCompare(student.StudentEmailId);
        return n1.includes(target) || n2.includes(target);
      });
    };

    // Try to find the student
    target =
      getStudentByIndexFromName(studentName) ||
      findStudentByLooseName(studentName);

    if (!target) {
      return {
        success: false,
        message: `Student not found: "${studentName}". Please try again with a valid name.`,
      };
    }

    // Handle the note based on command type
    let noteValue = "";
    let successMessage = "";

    switch (type) {
      case "addNote":
      case "updateNote":
        // Ensure noteText is properly extracted - check if it's null, undefined, or empty string
        noteValue = noteText && noteText.trim() ? noteText.trim() : "";

        // Fallback: If noteText is empty, try to extract from original command
        if (!noteValue && command.originalCommand) {
          const originalCmd = String(command.originalCommand).toLowerCase();
          const studentNameLower = String(studentName).toLowerCase();

          // Try to find text after common note command patterns
          const notePatterns = [
            /(?:añadir|add|agregar)\s+nota\s+(?:para|for)\s+(?:[^:]+?)\s+(.+)/i,
            /(?:note|nota)\s+(?:para|for|about)\s+(?:[^:]+?)\s+(.+)/i,
            /(?:añadir|add|agregar)\s+nota\s*[:]\s*(.+)/i,
          ];

          for (const pattern of notePatterns) {
            const match = command.originalCommand.match(pattern);
            if (match && match[1]) {
              noteValue = match[1].trim();
              console.log(
                "🔍 [handleSingleNoteCommand] Extracted note from fallback:",
                noteValue
              );
              break;
            }
          }

          // If still empty, try to extract everything after the student name
          if (!noteValue) {
            const nameIndex = originalCmd.indexOf(studentNameLower);
            if (nameIndex !== -1) {
              const afterName = command.originalCommand
                .substring(nameIndex + studentName.length)
                .trim();
              // Remove common command words
              const cleaned = afterName
                .replace(/^(añadir|add|agregar|note|nota|para|for)\s+/i, "")
                .replace(/^(es|is|was|está|estaba)\s+/i, "")
                .trim();
              if (cleaned && cleaned.length > 2) {
                noteValue = cleaned;
                console.log(
                  "🔍 [handleSingleNoteCommand] Extracted note from student name fallback:",
                  noteValue
                );
              }
            }
          }
        }

        // Debug logging
        console.log("🔍 [handleSingleNoteCommand] Note value being set:", {
          originalNoteText: noteText,
          trimmedNoteValue: noteValue,
          isEmpty: !noteValue,
          originalCommand: command.originalCommand,
        });

        if (!noteValue) {
          return {
            success: false,
            message: `No note text provided. Please include the note content in your command.`,
          };
        }

        successMessage = `Note ${
          type === "addNote" ? "added" : "updated"
        } for ${target.StudentName}: "${noteValue}"`;
        break;
      case "clearNote":
        noteValue = "";
        successMessage = `Note cleared for ${target.StudentName}`;
        break;
      default:
        return {
          success: false,
          message: `Unknown note command type: ${type}`,
        };
    }

    // Update the note using the existing studentNoteHandler and wait for completion
    try {
      const result = await this.studentNoteHandler(
        target.StudentEmailId,
        target.LessonId,
        noteValue
      );
      return {
        success: result.success,
        message: result.success ? successMessage : result.message,
      };
    } catch (error) {
      return {
        success: false,
        message: `Error updating note: ${error.message}`,
      };
    }
  };

  // Helper method to handle single attendance command
  handleSingleAttendanceCommand = (command) => {
    const { type, studentName, matchedStudent, originalCommand } = command;

    if (!this.state.showRecords || this.state.showRecords.length === 0) {
      return {
        success: false,
        message: "No students found for attendance management",
      };
    }

    let updatedStudents = [...this.state.showRecords];
    let successMessage = "";

    const normalizeForCompare = (str) => {
      if (!str) return "";
      let s = (" " + String(str).toLowerCase() + " ")
        .replace(/ student\s+/g, " ")
        .replace(/ one(?=\b)/g, " 1")
        .replace(/ two(?=\b)/g, " 2")
        .replace(/ three(?=\b)/g, " 3")
        .replace(/ four(?=\b)/g, " 4")
        .replace(/ five(?=\b)/g, " 5")
        .replace(/ six(?=\b)/g, " 6")
        .replace(/ seven(?=\b)/g, " 7")
        .replace(/ eight(?=\b)/g, " 8")
        .replace(/ nine(?=\b)/g, " 9")
        .replace(/ ten(?=\b)/g, " 10");
      return s.replace(/[^a-z0-9]/g, "");
    };

    const findStudentByLooseName = (needle) => {
      if (!needle || needle.trim() === "") return null;
      const target = normalizeForCompare(needle);

      // First try exact match
      const exactMatch = updatedStudents.find((student) => {
        return student.StudentName.toLowerCase() === needle.toLowerCase();
      });

      if (exactMatch) {
        return exactMatch;
      }

      // Then try loose match
      return updatedStudents.find((student) => {
        const n1 = normalizeForCompare(student.StudentName);
        const n2 = normalizeForCompare(student.StudentEmailId);
        return n1.includes(target) || n2.includes(target);
      });
    };

    const extractIndexFromName = (nameLike) => {
      if (!nameLike) return null;
      const lower = String(nameLike).toLowerCase();
      const wordToNum = {
        one: 1,
        two: 2,
        three: 3,
        four: 4,
        five: 5,
        six: 6,
        seven: 7,
        eight: 8,
        nine: 9,
        ten: 10,
        first: 1,
        second: 2,
        third: 3,
        fourth: 4,
        fifth: 5,
        sixth: 6,
        seventh: 7,
        eighth: 8,
        ninth: 9,
        tenth: 10,
      };
      const digitMatch = lower.match(/\b(\d{1,2})\b/);
      if (digitMatch) return parseInt(digitMatch[1], 10);
      for (const [word, num] of Object.entries(wordToNum)) {
        if (lower.includes(word)) return num;
      }
      return null;
    };

    const getStudentByIndexFromName = (nameLike) => {
      const idx = extractIndexFromName(nameLike);
      if (!idx || idx < 1 || idx > updatedStudents.length) return null;
      return updatedStudents[idx - 1];
    };

    // Handle single student attendance commands
    if (["present", "absent", "late"].includes(type)) {
      const applyStatus = (studentRecord) => {
        let statusValue = "Presente";
        if (type === "absent") statusValue = "Ausente";
        if (type === "late") statusValue = "Retardo";

        this.takeAttendance(
          studentRecord.StudentEmailId,
          studentRecord.LessonId,
          statusValue,
          this.props.user.username
        );
        successMessage = `${studentRecord.StudentName} marked as ${type}`;
      };

      if (matchedStudent) {
        applyStatus(matchedStudent);
      } else if (studentName) {
        const studentNumberMatch =
          studentName.match(/\d+/) ||
          (originalCommand && originalCommand.match(/\d+/));

        if (studentNumberMatch) {
          const studentNumber = studentNumberMatch[0];
          const matchedStudentByNumber = updatedStudents.find((s) =>
            s.StudentName.includes(studentNumber)
          );

          if (matchedStudentByNumber) {
            applyStatus(matchedStudentByNumber);
            return {
              success: true,
              message: successMessage,
            };
          }
        }

        const byIndex = getStudentByIndexFromName(studentName);
        const target = byIndex || findStudentByLooseName(studentName);

        if (target) {
          applyStatus(target);
        } else {
          return {
            success: false,
            message: `Student not found: "${studentName}". Please try again with a valid name.`,
          };
        }
      } else {
        return {
          success: false,
          message: "Please specify a student name",
        };
      }
    } else {
      return {
        success: false,
        message: `Invalid attendance command: ${type}`,
      };
    }

    return {
      success: true,
      message: successMessage,
    };
  };

  // Voice command handler for attendance management
  handleVoiceCommand = async (command) => {
    const {
      type,
      studentName,
      matchedStudent,
      originalCommand,
      multipleStudents,
      multipleCommands,
      lessonName,
      noteText,
      reason,
    } = command;

    // Fallback: honor undo/redo intents from raw speech using language-aware synonyms
    const rawText = originalCommand || "";
    if (rawText) {
      const langCode = getLanguageCode(this.props?.i18n?.language || "en");
      if (isUndoIntent(rawText, langCode)) {
        const result = await this._undoLastAction();
        if (result.success) {
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }
        return result;
      }
      if (isRedoIntent(rawText, langCode)) {
        const result = await this._redoLastAction();
        if (result.success) {
          toast.success(result.message);
        } else {
          toast.error(result.message);
        }
        return result;
      }
    }

    // Handle undo intent directly
    if (type === "undo") {
      const result = await this._undoLastAction();
      if (result.success) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
      return result;
    }

    // Handle redo intent directly
    if (type === "redo") {
      const result = await this._redoLastAction();
      if (result.success) {
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
      return result;
    }

    // Handle lesson navigation commands
    if (
      type === "navigateLesson" ||
      type === "goToLesson" ||
      type === "nextLesson" ||
      type === "previousLesson"
    ) {
      const { showLesson } = this.state;

      // Check if we have lessons available
      if (!showLesson || showLesson.length === 0) {
        console.log("No lessons available");
        return {
          success: false,
          message: "No lessons available for navigation.",
        };
      }

      // Find lesson by name using fuzzy matching
      if (type === "navigateLesson" || type === "goToLesson") {
        if (!lessonName) {
          console.log("No lesson name specified");
          return {
            success: false,
            message: "No lesson name specified.",
          };
        }

        // Find the best matching lesson
        const normalizedLessonName = lessonName.toLowerCase().trim();
        let bestMatch = null;
        let bestScore = 0;

        // Check if the lesson name contains a code (like "102")
        const codeMatch = normalizedLessonName.match(/\b(\d+)\b/);
        const lessonCode = codeMatch ? codeMatch[1] : null;

        showLesson.forEach((lesson) => {
          const lessonTitle = lesson.Title ? lesson.Title.toLowerCase() : "";
          const className = lesson.ClassName
            ? lesson.ClassName.toLowerCase()
            : "";

          let score = 0;

          // Priority 1: Exact match with the full lesson name (highest priority)
          if (
            className === normalizedLessonName ||
            lessonTitle === normalizedLessonName
          ) {
            score = 1.0; // Perfect match
          }
          // Priority 2: Dynamic subject name match - extract subject from lesson name and match with class name
          else if (lessonCode) {
            // Extract subject from lesson name (everything before the number)
            const subjectPart = normalizedLessonName
              .replace(lessonCode, "")
              .trim();
            if (subjectPart && className.includes(subjectPart)) {
              // Check if the number also matches
              if (className.includes(lessonCode)) {
                score = 0.95; // Very high score for subject + number match
              } else {
                score = 0.85; // High score for subject match only
              }
            }
          }
          // Priority 3: If a specific code was mentioned, check for exact code matches in class identifiers
          if (score === 0 && lessonCode) {
            // Only consider it a code match if the code appears as a standalone number in the class name
            const classNumberPattern = new RegExp(`\\b${lessonCode}\\b`);
            if (
              classNumberPattern.test(className) ||
              classNumberPattern.test(lessonTitle)
            ) {
              score = 0.8; // Good score for exact code matches
            }
            // Lower score for partial code matches (like "5" in "347")
            else if (
              className.includes(lessonCode) ||
              lessonTitle.includes(lessonCode)
            ) {
              score = 0.3; // Lower score for partial matches
            }
          }

          // Priority 5: General string similarity check
          if (score === 0) {
            // Check if the lesson name is in the ClassName (preferred)
            if (
              className.includes(normalizedLessonName) ||
              normalizedLessonName.includes(className)
            ) {
              score =
                Math.min(normalizedLessonName.length, className.length) /
                Math.max(normalizedLessonName.length, className.length);
              // Give higher weight to ClassName matches
              score = score * 0.7; // Reduced weight for general matches
            }

            // Also check Title as fallback
            if (
              lessonTitle.includes(normalizedLessonName) ||
              normalizedLessonName.includes(lessonTitle)
            ) {
              const titleScore =
                Math.min(normalizedLessonName.length, lessonTitle.length) /
                Math.max(normalizedLessonName.length, lessonTitle.length);
              // Use the higher score between ClassName and Title
              score = Math.max(score, titleScore * 0.6); // Reduced weight for title matches
            }
          }

          if (score > bestScore) {
            bestScore = score;
            bestMatch = lesson;
          }
        });

        if (bestMatch && bestScore > 0.25) {
          // Higher threshold for more accurate matching

          // Find the card element and trigger a click on it
          // Use unique LessonId for element lookup to avoid duplicate title issues
          const lessonKey = this.getLessonDomKey(bestMatch);

          try {
            // Track navigation for undo/redo
            const prevLesson = this.state.selectedLesson;
            if (!this.isPerformingUndo && prevLesson && bestMatch) {
              const { showLesson } = this.state;
              this._pushUndoAction({
                type: "lesson",
                previous: prevLesson.LessonId,
                next: bestMatch.LessonId,
                previousKey: this.getLessonDomKey(prevLesson),
                nextKey: this.getLessonDomKey(bestMatch),
                previousSnapshot: this.buildLessonSnapshot(prevLesson),
                nextSnapshot: this.buildLessonSnapshot(bestMatch),
                previousIndex: this.findLessonIndex(prevLesson, showLesson),
                nextIndex: this.findLessonIndex(bestMatch, showLesson),
              });
            }
            // Set the state
            this.setState({ selectedLesson: bestMatch }, () => {
              // After state is updated, fetch records directly
              this.fetchRecordsByLesson();

              // Also try to find and click the card element if possible
              setTimeout(() => {
                const selector = `[data-lesson-id="${lessonKey}"]`;
                const cardElement = document.querySelector(selector);
                console.log("[VOICE] Card lookup after selection:", {
                  selector,
                  found: !!cardElement,
                });
                if (cardElement) {
                  // Avoid double undo push from the card click handler
                  this.isProgrammaticLessonClick = true;
                  try {
                    cardElement.click();
                  } finally {
                    this.isProgrammaticLessonClick = false;
                  }
                }
              }, 100);
            });

            return {
              success: true,
              message: `Navigating to lesson: ${
                bestMatch.ClassName || bestMatch.Title || "seleccionada"
              }`,
            };
          } catch (error) {
            console.error("Error navigating to lesson:", error);
            return {
              success: false,
              message: "Error navigating to lesson. Please try again.",
            };
          }
        } else {
          console.log("No matching lesson found");
          return {
            success: false,
            message: `Lesson "${lessonName}" not found.`,
          };
        }
      }

      // Handle next/previous lesson navigation
      if (type === "nextLesson" || type === "previousLesson") {
        const { selectedLesson } = this.state;
        if (!selectedLesson) {
          // If no lesson is selected, select the first one for "next" or the last one for "previous"
          const targetLesson =
            type === "nextLesson"
              ? showLesson[0]
              : showLesson[showLesson.length - 1];
          this.setState({ selectedLesson: targetLesson });
          return {
            success: true,
            message: `Navigating to lesson: ${
              targetLesson.Title || "selected"
            }`,
          };
        }

        // Find the index of the currently selected lesson
        // Normalize ID comparison and fall back to stable key
        let currentIndex = -1;
        const selId = selectedLesson?.LessonId;
        if (selId !== undefined && selId !== null && selId !== "") {
          currentIndex = showLesson.findIndex(
            (lesson) => String(lesson?.LessonId) === String(selId)
          );
        }
        if (currentIndex === -1) {
          const selectedKey = this.getLessonDomKey(selectedLesson);
          currentIndex = showLesson.findIndex(
            (lesson) => this.getLessonDomKey(lesson) === selectedKey
          );
        }

        if (currentIndex === -1) {
          // Current lesson not found in the list
          return {
            success: false,
            message: "Could not determine the current lesson.",
          };
        }

        // Calculate the next or previous index
        let newIndex;
        if (type === "nextLesson") {
          newIndex = (currentIndex + 1) % showLesson.length;
        } else {
          // previousLesson
          newIndex = (currentIndex - 1 + showLesson.length) % showLesson.length;
        }

        const targetLesson = showLesson[newIndex];
        // Track navigation for undo/redo
        const prevLesson = this.state.selectedLesson;
        if (!this.isPerformingUndo && prevLesson && targetLesson) {
          const { showLesson } = this.state;
          this._pushUndoAction({
            type: "lesson",
            previous: prevLesson.LessonId,
            next: targetLesson.LessonId,
            previousKey: this.getLessonDomKey(prevLesson),
            nextKey: this.getLessonDomKey(targetLesson),
            previousSnapshot: this.buildLessonSnapshot(prevLesson),
            nextSnapshot: this.buildLessonSnapshot(targetLesson),
            previousIndex: this.findLessonIndex(prevLesson, showLesson),
            nextIndex: this.findLessonIndex(targetLesson, showLesson),
          });
        }
        // Set selection
        this.setState({ selectedLesson: targetLesson });

        return {
          success: true,
          message: `Navigating to lesson ${
            type === "nextLesson" ? "siguiente" : "anterior"
          }: ${targetLesson.Title || "seleccionada"}`,
        };
      }
    }

    // Handle multiple commands (combining different actions)
    if (type === "multipleCommands" && multipleCommands) {
      if (!this.state.showRecords || this.state.showRecords.length === 0) {
        return {
          success: false,
          message: "No students found for command execution",
        };
      }

      const results = [];
      let hasErrors = false;
      let errorMessages = [];

      // Process each command in sequence
      for (const cmd of multipleCommands) {
        // Create a single command object to pass to the handler
        const singleCommand = {
          type: cmd.type,
          studentName: cmd.studentName,
          noteText: cmd.noteText,
          matchedStudent: cmd.matchedStudent,
          originalCommand: command.originalCommand,
        };

        // Handle the individual command
        if (
          cmd.type === "addNote" ||
          cmd.type === "updateNote" ||
          cmd.type === "clearNote"
        ) {
          // Handle notes command - await the async operation
          try {
            const result = await this.handleSingleNoteCommand(singleCommand);
            if (result.success) {
              results.push(result.message);
            } else {
              hasErrors = true;
              errorMessages.push(result.message);
            }
          } catch (error) {
            hasErrors = true;
            errorMessages.push(
              `Error processing note command: ${error.message}`
            );
          }
        } else if (
          [
            "present",
            "absent",
            "late",
            "presentAll",
            "absentAll",
            "lateAll",
            "presentExcept",
            "absentExcept",
            "lateExcept",
          ].includes(cmd.type)
        ) {
          // Handle attendance command
          const result = this.handleSingleAttendanceCommand(singleCommand);
          if (result.success) {
            results.push(result.message);
          } else {
            hasErrors = true;
            errorMessages.push(result.message);
          }
        } else {
          hasErrors = true;
          errorMessages.push(`Unknown command type: ${cmd.type}`);
        }
      }

      if (hasErrors) {
        return {
          success: false,
          message: `Some commands failed: ${errorMessages.join(", ")}`,
        };
      }

      return {
        success: true,
        message: `Multiple commands executed: ${results.join("; ")}`,
      };
    }

    // Handle student notes commands
    if (type === "addNote" || type === "updateNote" || type === "clearNote") {
      const singleCommand = {
        type: type,
        studentName: studentName,
        noteText: noteText,
        originalCommand: originalCommand,
      };

      // Use the handleSingleNoteCommand function
      return await this.handleSingleNoteCommand(singleCommand);
    }

    // Handle attendance commands (existing functionality)
    if (!this.state.showRecords || this.state.showRecords.length === 0) {
      return {
        success: false,
        message: "No students found for attendance management",
      };
    }

    if (!type) {
      return {
        success: false,
        message: "Command not recognized. Please re-say clearly and try again.",
      };
    }

    let updatedStudents = [...this.state.showRecords];
    let successMessage = "";

    const normalizeForCompare = (str) => {
      if (!str) return "";
      let s = (" " + String(str).toLowerCase() + " ")
        .replace(/ student\s+/g, " ")
        .replace(/ one(?=\b)/g, " 1")
        .replace(/ two(?=\b)/g, " 2")
        .replace(/ three(?=\b)/g, " 3")
        .replace(/ four(?=\b)/g, " 4")
        .replace(/ five(?=\b)/g, " 5")
        .replace(/ six(?=\b)/g, " 6")
        .replace(/ seven(?=\b)/g, " 7")
        .replace(/ eight(?=\b)/g, " 8")
        .replace(/ nine(?=\b)/g, " 9")
        .replace(/ ten(?=\b)/g, " 10");
      return s.replace(/[^a-z0-9]/g, "");
    };
    const findStudentByLooseName = (needle) => {
      if (!needle || needle.trim() === "") return null;
      const target = normalizeForCompare(needle);

      // First try exact match on student number (like "Student 01")
      const exactMatch = updatedStudents.find((student) => {
        return student.StudentName.toLowerCase() === needle.toLowerCase();
      });

      if (exactMatch) {
        return exactMatch;
      }

      // Then try loose match
      return updatedStudents.find((student) => {
        const n1 = normalizeForCompare(student.StudentName);
        const n2 = normalizeForCompare(student.StudentEmailId);
        return n1.includes(target) || n2.includes(target);
      });
    };

    // Interpret ordinals and numbers in phrases like "student two", "second student", "student 3"
    const extractIndexFromName = (nameLike) => {
      if (!nameLike) return null;
      const lower = String(nameLike).toLowerCase();
      const wordToNum = {
        one: 1,
        two: 2,
        three: 3,
        four: 4,
        five: 5,
        six: 6,
        seven: 7,
        eight: 8,
        nine: 9,
        ten: 10,
        first: 1,
        second: 2,
        third: 3,
        fourth: 4,
        fifth: 5,
        sixth: 6,
        seventh: 7,
        eighth: 8,
        ninth: 9,
        tenth: 10,
      };
      const digitMatch = lower.match(/\b(\d{1,2})\b/);
      if (digitMatch) return parseInt(digitMatch[1], 10);
      for (const [word, num] of Object.entries(wordToNum)) {
        if (lower.includes(word)) return num;
      }
      return null;
    };

    const getStudentByIndexFromName = (nameLike) => {
      const idx1 = extractIndexFromName(nameLike);
      if (!idx1 || idx1 < 1 || idx1 > updatedStudents.length) return null;
      return updatedStudents[idx1 - 1];
    };

    const performAttendanceUpdate = (studentRecord, statusValue) => {
      this.takeAttendance(
        studentRecord.StudentEmailId,
        studentRecord.LessonId,
        statusValue,
        this.props.user.username
      );
    };

    const normalizeReason = (s) => {
      if (!s) return null;
      const v = String(s).toLowerCase().trim();
      const n = v
        .replace(/[\p{P}\p{S}]/gu, "")
        .replace(/\s+/g, " ")
        .trim();
      const lc = getLanguageCode(this.props?.i18n?.language || "en");
      const sick = [
        "sickness",
        "sick",
        "ill",
        "illness",
        "unwell",
        "not well",
        "not feeling well",
        "no se siente bien",
        "enfermo",
        "enferma",
        "enfermedad",
        "doenca",
        "doença",
        "doente",
        "nao se sente bem",
        "não se sente bem",
        "mal estar",
        "malestar",
        "maladie",
        "malade",
        "ne se sent pas bien",
        "krank",
        "krankheit",
        "fühlt sich nicht gut",
        "non si sente bene",
        "malattia",
        "malato",
        "malata",
        "बीमार",
        "बिमारी",
        "तबियत खराब",
        "病気",
        "具合が悪い",
      ];
      const family = [
        "family emergency",
        "emergency",
        "emergencia familiar",
        "emergência familiar",
        "urgence familiale",
        "familiäre notlage",
        "emergenza familiare",
        "परिवार में आपातकाल",
        "家族の緊急事態",
      ];
      const notWell = [
        "not feel well",
        "not feeling well",
        "unwell",
        "no se siente bien",
        "não se sente bem",
        "ne se sent pas bien",
        "fühlt sich nicht gut",
        "non si sente bene",
        "具合が悪い",
        "तबियत खराब",
      ];
      const testAny = (arr) => arr.some((x) => n.includes(x));
      if (testAny(sick)) return "Sickness";
      if (testAny(family)) return "Family emergency";
      if (testAny(notWell)) return "Not feel well";
      return null;
    };

    const requestedReason = normalizeReason(reason || originalCommand);

    switch (type) {
      case "present":
        // Handle single student present command
        if (matchedStudent) {
          performAttendanceUpdate(matchedStudent, "Presente");
          successMessage = `${matchedStudent.StudentName} marked as present`;
        } else if (studentName) {
          // Extract student number if present in the command
          const studentNumberMatch =
            studentName.match(/\d+/) ||
            (originalCommand && originalCommand.match(/\d+/));

          if (studentNumberMatch) {
            const studentNumber = studentNumberMatch[0];

            // Find student with matching number in name
            const matchedStudentByNumber = updatedStudents.find((s) =>
              s.StudentName.includes(studentNumber)
            );

            if (matchedStudentByNumber) {
              console.log(
                `Found student by number: ${matchedStudentByNumber.StudentName}`
              );
              performAttendanceUpdate(matchedStudentByNumber, "Presente");
              successMessage = `${matchedStudentByNumber.StudentName} marked as present`;
              break;
            }
          }

          // Regular matching for other students
          const byIndex = getStudentByIndexFromName(studentName);
          let target = byIndex || findStudentByLooseName(studentName);

          if (target) {
            performAttendanceUpdate(target, "Presente");
            successMessage = `${target.StudentName} marked as present`;
          } else {
            // Return error when student is not found
            return {
              success: false,
              message: `Student not found: "${studentName}". Please try again with a valid name.`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "absent":
        // Treat base "absent" as single-student action when a name/index is provided
        if (matchedStudent) {
          performAttendanceUpdate(
            matchedStudent,
            requestedReason || "Ausente"
          );
          successMessage = `${matchedStudent.StudentName} marked as absent`;
        } else if (studentName) {
          const studentNumberMatch =
            studentName.match(/\d+/) ||
            (originalCommand && originalCommand.match(/\d+/));

          if (studentNumberMatch) {
            const studentNumber = studentNumberMatch[0];
            const matchedStudentByNumber = updatedStudents.find((s) =>
              s.StudentName.includes(studentNumber)
            );

            if (matchedStudentByNumber) {
              performAttendanceUpdate(
                matchedStudentByNumber,
                requestedReason || "Ausente"
              );
              successMessage = `${matchedStudentByNumber.StudentName} marked as absent`;
              break;
            }
          }

          const byIndex = getStudentByIndexFromName(studentName);
          const target = byIndex || findStudentByLooseName(studentName);
          if (target) {
            performAttendanceUpdate(target, requestedReason || "Ausente");
            successMessage = `${target.StudentName} marked as absent`;
          } else {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "late":
        // Treat base "late" as single-student action when a name/index is provided
        if (matchedStudent) {
          performAttendanceUpdate(matchedStudent, "Retardo");
          successMessage = `${matchedStudent.StudentName} marked as late`;
        } else if (studentName) {
          const byIndex = getStudentByIndexFromName(studentName);
          const target = byIndex || findStudentByLooseName(studentName);
          if (target) {
            performAttendanceUpdate(target, "Retardo");
            successMessage = `${target.StudentName} marked as late`;
          } else {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "multipleStudents":
        // Handle multiple students with different statuses
        if (
          multipleStudents &&
          Array.isArray(multipleStudents) &&
          multipleStudents.length > 0
        ) {
          const processedStudents = [];

          multipleStudents.forEach((student) => {
            const { studentName, type, matchedStudent } = student;

            if (matchedStudent) {
              let statusValue = "Presente";
              if (type.toLowerCase() === "absent") statusValue = "Ausente";
              if (type.toLowerCase() === "late") statusValue = "Retardo";

              this.takeAttendance(
                matchedStudent.StudentEmailId,
                matchedStudent.LessonId,
                statusValue,
                this.props.user.username
              );
              processedStudents.push(`${matchedStudent.StudentName} (${type})`);
            }
          });

          if (processedStudents.length > 0) {
            successMessage = `Updated attendance for: ${processedStudents.join(
              ", "
            )}`;
          } else {
            return {
              success: false,
              message: "Could not match any students in the command",
            };
          }
        } else {
          return {
            success: false,
            message: "No student information provided in the command",
          };
        }
        break;

      case "presentAll":
        // Mark all students as present
        updatedStudents.forEach((student, index) => {
          this.takeAttendance(
            student.StudentEmailId,
            student.LessonId,
            "Presente",
            this.props.user.username
          );
        });
        successMessage = "All students marked as present";
        break;

      case "presentSingle":
        if (studentName) {
          const byIndex = getStudentByIndexFromName(studentName);
          const target = byIndex || findStudentByLooseName(studentName);
          if (target) {
            this.takeAttendance(
              target.StudentEmailId,
              target.LessonId,
              "Presente",
              this.props.user.username
            );
            successMessage = `${target.StudentName} marked as present`;
          } else {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "absent":
        if (studentName) {
          const byIndex2 = getStudentByIndexFromName(studentName);
          const target2 = byIndex2 || findStudentByLooseName(studentName);
          if (target2) {
            this.takeAttendance(
              target2.StudentEmailId,
              target2.LessonId,
              requestedReason || "Ausente",
              this.props.user.username
            );
            successMessage = `${target2.StudentName} marked as absent`;
          } else {
            return {
              success: false,
              message: `Student not found: "${studentName}". Please try again with a valid name.`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "late":
        if (studentName) {
          const byIndex = getStudentByIndexFromName(studentName);
          const target = byIndex || findStudentByLooseName(studentName);
          if (target) {
            this.takeAttendance(
              target.StudentEmailId,
              target.LessonId,
              "Retardo",
              this.props.user.username
            );
            successMessage = `${target.StudentName} marked as late`;
          } else {
            // Return error when student is not found
            return {
              success: false,
              message: `Student not found: "${studentName}". Please try again with a valid name.`,
            };
          }
        } else {
          return { success: false, message: "Please specify a student name" };
        }
        break;

      case "absentAll":
        // Mark all students as absent
        updatedStudents.forEach((student, index) => {
          this.takeAttendance(
            student.StudentEmailId,
            student.LessonId,
            "Ausente",
            this.props.user.username
          );
        });
        successMessage = "All students marked as absent";
        break;

      case "lateAll":
        // Mark all students as late
        updatedStudents.forEach((student, index) => {
          this.takeAttendance(
            student.StudentEmailId,
            student.LessonId,
            "Retardo",
            this.props.user.username
          );
        });
        successMessage = "All students marked as late";
        break;

      case "presentExcept":
        // Mark all present except specified student (excluded remains unchanged)
        if (studentName) {
          const studentToExclude = findStudentByLooseName(studentName);
          if (!studentToExclude) {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
          updatedStudents.forEach((student) => {
            if (student.StudentEmailId !== studentToExclude?.StudentEmailId) {
              this.takeAttendance(
                student.StudentEmailId,
                student.LessonId,
                "Presente",
                this.props.user.username
              );
            }
          });
          successMessage = `All students marked present except ${studentName}`;
        } else {
          return {
            success: false,
            message: "Please specify a student name to exclude",
          };
        }
        break;

      case "absentExcept":
        // Mark all absent except specified student (excluded remains unchanged)
        if (studentName) {
          const studentToExclude = findStudentByLooseName(studentName);
          if (!studentToExclude) {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
          updatedStudents.forEach((student) => {
            if (student.StudentEmailId !== studentToExclude?.StudentEmailId) {
              this.takeAttendance(
                student.StudentEmailId,
                student.LessonId,
                "Ausente",
                this.props.user.username
              );
            }
          });
          successMessage = `All students marked absent except ${studentName}`;
        } else {
          return {
            success: false,
            message: "Please specify a student name to exclude",
          };
        }
        break;

      case "lateExcept":
        // Mark all late except specified student (excluded remains unchanged)
        if (studentName) {
          const studentToExclude = findStudentByLooseName(studentName);
          if (!studentToExclude) {
            return {
              success: false,
              message: `Could not find student: ${studentName}`,
            };
          }
          updatedStudents.forEach((student) => {
            if (student.StudentEmailId !== studentToExclude?.StudentEmailId) {
              this.takeAttendance(
                student.StudentEmailId,
                student.LessonId,
                "Retardo",
                this.props.user.username
              );
            }
          });
          successMessage = `All students marked late except ${studentName}`;
        } else {
          return {
            success: false,
            message: "Please specify a student name to exclude",
          };
        }
        break;

      default:
        return {
          success: false,
          message: `Command "${originalCommand}" not recognized. Try: "mark all present", "set absent", "present except [name]"`,
        };
    }

    if (successMessage) {
      toast.success(successMessage);
      return { success: true, message: successMessage };
    }

    return { success: false, message: "Unknown error occurred" };
  };

  // --- Undo helpers ---
  _pushUndoAction = (action) => {
    try {
      const entry = {
        timestamp: Date.now(),
        ...action,
      };
      // Keep a single fallback reference outside the stack
      this.lastAction = entry;
      try {
        sessionStorage.setItem(
          "ACV_ATTENDANCE_LAST_ACTION",
          JSON.stringify(entry)
        );
      } catch (e) {
        // Storage may be unavailable in some environments
      }
      this.undoStack.push(entry);
      if (this.undoStack.length > this.maxUndoItems) {
        this.undoStack.shift();
      }
      console.log(
        "[UNDO] Pushed entry:",
        entry,
        "stackLen:",
        this.undoStack?.length
      );
    } catch (e) {
      console.log("Failed to push undo action:", e?.message);
    }
  };

  _undoLastAction = async () => {
    console.log(
      "[UNDO] Attempting undo. Stack length:",
      this.undoStack?.length,
      "has fallback:",
      !!this.lastAction
    );
    let last = null;
    if (!this.undoStack || this.undoStack.length === 0) {
      // Use fallback lastAction when stack is empty
      if (this.lastAction) {
        last = this.lastAction;
        this.lastAction = null;
        try {
          sessionStorage.removeItem("ACV_ATTENDANCE_LAST_ACTION");
        } catch (e) {}
      } else {
        // Try persistent fallback
        try {
          const saved = sessionStorage.getItem("ACV_ATTENDANCE_LAST_ACTION");
          if (saved) {
            last = JSON.parse(saved);
            sessionStorage.removeItem("ACV_ATTENDANCE_LAST_ACTION");
          } else {
            return { success: false, message: "No recent action to undo." };
          }
        } catch (e) {
          return { success: false, message: "No recent action to undo." };
        }
      }
    } else {
      last = this.undoStack.pop();
    }
    console.log("[UNDO] Restoring:", last);

    try {
      // Prevent re-pushing while performing undo
      this.isPerformingUndo = true;
      if (last.type === "attendance") {
        if (last.previous == null) {
          // If previous status unknown, clear to default NULL
          this.takeAttendance(
            last.email,
            last.lessonId,
            "NULL",
            this.props.user.username
          );
          return {
            success: true,
            message: "Reverted last attendance change (cleared).",
          };
        }
        this.takeAttendance(
          last.email,
          last.lessonId,
          last.previous,
          this.props.user.username
        );
        return { success: true, message: "Reverted last attendance change." };
      }
      if (last.type === "note") {
        await this.studentNoteHandler(
          last.email,
          last.lessonId,
          last.previous || ""
        );
        return { success: true, message: "Reverted last note update." };
      }
      if (last.type === "lesson") {
        const { showLesson } = this.state;
        // Try strict ID match first only when ID is defined
        let prev = null;
        const prevId = last?.previous;
        if (prevId !== undefined && prevId !== null && prevId !== "") {
          prev = (showLesson || []).find(
            (l) => String(l?.LessonId) === String(prevId)
          );
        }
        // Fall back to stable DOM key if ID mismatch/missing
        if (!prev && last?.previousKey) {
          prev = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === last.previousKey
          );
        }
        // Final fallback: match by snapshot composite key
        if (!prev && last?.previousSnapshot) {
          const snapKey = this.getLessonDomKey(last.previousSnapshot);
          prev = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === snapKey
          );
        }
        // Index-based fallback with key verification to avoid wrong selection
        if (!prev && typeof last?.previousIndex === "number") {
          const idx = last.previousIndex;
          if (idx >= 0 && idx < (showLesson || []).length) {
            const candidate = showLesson[idx];
            const candidateKey = this.getLessonDomKey(candidate);
            const priorKey =
              last?.previousKey ||
              (last?.previousSnapshot
                ? this.getLessonDomKey(last.previousSnapshot)
                : null);
            if (!priorKey || candidateKey === priorKey) {
              prev = candidate;
            } else {
              console.log(
                "[UNDO] Index fallback key mismatch; skipping index selection.",
                { idx, candidateKey, priorKey }
              );
            }
          }
        }
        console.log("[UNDO] Lesson revert lookup:", {
          previousId: last?.previous,
          previousKey: last?.previousKey,
          previousSnapKey: last?.previousSnapshot
            ? this.getLessonDomKey(last.previousSnapshot)
            : null,
          previousIndex: last?.previousIndex,
          showLessonIds: (showLesson || []).map((l) => l.LessonId),
          found: !!prev,
        });
        if (prev) {
          this.setState({ selectedLesson: prev }, () => {
            console.log("[UNDO] Selected lesson set to previous:", {
              lessonId: prev?.LessonId,
              title: prev?.Title,
              domKey: this.getLessonDomKey(prev),
            });
            this.fetchRecordsByLesson();
          });
          return { success: true, message: "Reverted last lesson change." };
        }
        // If no previous target was specified in the entry, this implies clearing selection
        const noPrevSpecified =
          (last?.previous === undefined ||
            last?.previous === null ||
            last?.previous === "") &&
          !last?.previousKey &&
          !last?.previousSnapshot &&
          !(typeof last?.previousIndex === "number" && last.previousIndex >= 0);
        if (noPrevSpecified) {
          this.setState({ selectedLesson: null, showRecords: [] });
          console.log(
            "[UNDO] Cleared lesson selection (no previous target specified)"
          );
          return { success: true, message: "Cleared lesson selection." };
        }
        return {
          success: false,
          message: "Previous lesson not found to undo.",
        };
      }
      // Unknown type
      return { success: false, message: "Nothing to undo for last action." };
    } catch (e) {
      console.log("Undo failed:", e?.message);
      return { success: false, message: "Undo failed. Please try again." };
    } finally {
      // After a successful undo attempt, push the undone entry to redo stack
      try {
        if (last) {
          this.redoStack.push(last);
          if (this.redoStack.length > this.maxUndoItems) this.redoStack.shift();
        }
      } catch (e) {}
      console.log("[UNDO] Done. redoStackLen:", this.redoStack?.length);
      this.isPerformingUndo = false;
    }
  };

  _redoLastAction = async () => {
    console.log(
      "[REDO] Attempting redo. Stack length:",
      this.redoStack?.length
    );
    if (!this.redoStack || this.redoStack.length === 0) {
      return { success: false, message: "No recent action to redo." };
    }
    const last = this.redoStack.pop();
    console.log("[REDO] Restoring:", last);
    try {
      this.isPerformingUndo = true;
      if (last.type === "attendance") {
        this.takeAttendance(
          last.email,
          last.lessonId,
          last.next,
          this.props.user.username
        );
        // After redo, make it undoable again
        this._pushUndoAction(last);
        return { success: true, message: "Reapplied last attendance change." };
      }
      if (last.type === "note") {
        await this.studentNoteHandler(
          last.email,
          last.lessonId,
          last.next || ""
        );
        this._pushUndoAction(last);
        return { success: true, message: "Reapplied last note update." };
      }
      if (last.type === "lesson") {
        const { showLesson } = this.state;
        // Try strict ID match first, normalizing type
        let nextLsn = null;
        const nextId = last?.next;
        if (nextId !== undefined && nextId !== null && nextId !== "") {
          nextLsn = (showLesson || []).find(
            (l) => String(l?.LessonId) === String(nextId)
          );
        }
        // Fall back to stable DOM key
        if (!nextLsn && last?.nextKey) {
          nextLsn = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === last.nextKey
          );
        }
        // Final fallback: match by snapshot composite key
        if (!nextLsn && last?.nextSnapshot) {
          const snapKey = this.getLessonDomKey(last.nextSnapshot);
          nextLsn = (showLesson || []).find(
            (l) => this.getLessonDomKey(l) === snapKey
          );
        }
        // Index-based fallback with key verification to avoid wrong selection
        if (!nextLsn && typeof last?.nextIndex === "number") {
          const idx = last.nextIndex;
          if (idx >= 0 && idx < (showLesson || []).length) {
            const candidate = showLesson[idx];
            const candidateKey = this.getLessonDomKey(candidate);
            const nextKey =
              last?.nextKey ||
              (last?.nextSnapshot
                ? this.getLessonDomKey(last.nextSnapshot)
                : null);
            if (!nextKey || candidateKey === nextKey) {
              nextLsn = candidate;
            } else {
              console.log(
                "[REDO] Index fallback key mismatch; skipping index selection.",
                { idx, candidateKey, nextKey }
              );
            }
          }
        }
        console.log("[REDO] Lesson reapply lookup:", {
          nextId: last?.next,
          nextKey: last?.nextKey,
          nextSnapKey: last?.nextSnapshot
            ? this.getLessonDomKey(last.nextSnapshot)
            : null,
          nextIndex: last?.nextIndex,
          showLessonIds: (showLesson || []).map((l) => l.LessonId),
          found: !!nextLsn,
        });
        if (nextLsn) {
          this.setState({ selectedLesson: nextLsn }, () => {
            console.log("[REDO] Selected lesson set to next:", {
              lessonId: nextLsn?.LessonId,
              title: nextLsn?.Title,
              domKey: this.getLessonDomKey(nextLsn),
            });
            this.fetchRecordsByLesson();
          });
          this._pushUndoAction(last);
          return { success: true, message: "Reapplied last lesson change." };
        }
        // If no next target was specified in the entry, this implies clearing selection
        const noNextSpecified =
          (last?.next === undefined ||
            last?.next === null ||
            last?.next === "") &&
          !last?.nextKey &&
          !last?.nextSnapshot &&
          !(typeof last?.nextIndex === "number" && last.nextIndex >= 0);
        if (noNextSpecified) {
          this.setState({ selectedLesson: null, showRecords: [] });
          console.log(
            "[REDO] Cleared lesson selection (no next target specified)"
          );
          return { success: true, message: "Cleared lesson selection." };
        }
        return { success: false, message: "Next lesson not found to redo." };
      }
      return { success: false, message: "Nothing to redo for last action." };
    } catch (e) {
      console.log("Redo failed:", e?.message);
      return { success: false, message: "Redo failed. Please try again." };
    } finally {
      this.isPerformingUndo = false;
    }
  };

  render() {
    const { user, t } = this.props;
    const { isCompactMode } = this.state;

    const styles = {
      cardImg: {
        width: "72px",
        height: "56px",
        right: "220px",
        marginLeft: "6px",
        marginTop: "6px",
        marginBottom: "6px",
        borderRadius: "7px",
      },
      topic: {
        display: this.state.showTopic ? "block" : "none",
        position: "absolute",
        left: this.state.isSmall ? 0 : "20px",
        bottom: this.state.isSmall ? 0 : "20px",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        minHeight: "260px",
        width: this.state.isSmall ? "-webkit-fill-available" : "340px",
        background: "white",
        borderRadius: "5px",
        zIndex: 2,
      },
      notes: {
        display: this.state.showNote ? "block" : "none",
        position: "absolute",
        left: this.state.isSmall ? 0 : this.state.showTopic ? "380px" : "20px",
        bottom: this.state.isSmall ? 0 : "20px",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
        minHeight: "260px",
        width: this.state.isSmall ? "-webkit-fill-available" : "340px",
        background: "white",
        borderRadius: "5px",
        zIndex: 2,
      },
      present: { backgroundColor: "#2F80ED", color: "white" },
      absent: {
        backgroundColor: "#EB5757",
        color: "white",
        marginLeft: "-10px",
      },
      justify: {
        backgroundColor: "#17a2b8",
        color: "white",
        marginLeft: "-10px",
      },
      home: { backgroundColor: "#04c68a", color: "white", marginLeft: "-10px" },
      late: { backgroundColor: "#464775", color: "white", marginLeft: "-10px" },
      btnPresent: { minWidth: "70px", marginLeft: "-10px" },
      btnAbsent: { minWidth: "66px", marginLeft: "-10px" },
      btnLate: { minWidth: "48px", marginLeft: "-10px" },
      btnHome: { minWidth: "48px", marginLeft: "-10px" },
      hideText: {
        whiteSpace: "nowrap",
        width: "180px",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    };

    const isVirtual = this.state.showRecords?.length
      ? this.state.showRecords.length ===
        this.state.showRecordsAnalytics.virtual
      : false;

    const header = {
      key: "header",
      items: [
        {
          content: (
            <Flex className="multi-slc">
              <Flex
                vAlign="center"
                hAlign="center"
                onClick={this.handleCheckMultipleRecords}
              >
                <HomeOutlined htmlColor={isVirtual ? "#7ddb7d" : "#b1b4b1"} />
              </Flex>
              {/* <Checkbox
                // checked={student.ClassType === "Virtual" ? true : false}
                className={
                  this.state.showRecords?.length ===
                  this.state.showRecordsAnalytics.virtual
                    ? "checkBoxImage checked"
                    : "checkBoxImage"
                }
                onChange={(e, { checked }) => {
                  let showRecords = this.state.showRecords.slice();
                  let listRecords = [];
                  showRecords = showRecords.map((student) => {
                    student.ClassType = checked ? "Virtual" : "Hybrid";
                    listRecords.push(student.StudentEmailId);
                    // return student;
                  });
                  // this.setState({ showRecords });
                  if (checked) {
                    this.checkedRecordsModeHandler({
                      lessonId: this.state.selectedLesson.Title
                        ? this.state.selectedLesson.Title
                        : this.state.selectedLesson?.LessonId,
                      studentId: listRecords,
                      mode: "Virtual",
                    });
                  } else {
                    this.checkedRecordsModeHandler({
                      lessonId: this.state.selectedLesson.Title
                        ? this.state.selectedLesson.Title
                        : this.state.selectedLesson?.LessonId,
                      studentId: listRecords,
                      mode: "Hybrid",
                    });
                  }
                }}
                checked={
                  this.state.showRecords?.length
                    ? this.state.showRecords.length ===
                      this.state.showRecordsAnalytics.virtual
                    : false
                }
                styles={{
                  marginTop: "0px",
                }}
              /> */}
              <Checkbox
                checked={
                  this.state.showRecords?.length
                    ? this.state.checkedRecords.filter(
                        (r) =>
                          String(r.LessonId) ===
                          String(this.state.selectedLesson?.LessonId)
                      ).length === this.state.showRecordsAnalytics.total
                    : false
                }
                onChange={(e, { checked }) => {
                  if (checked) {
                    let showRecords = [...this.state.showRecords];
                    let chkRecords = showRecords.map((student) => {
                      return {
                        Attendance: student.Attendance,
                        AttendanceTakenBy: student.AttendanceTakenBy,
                        ClassId: student.ClassId,
                        ClassName: student.ClassName,
                        EndTime: student.EndTime,
                        LessonDate: student.LessonDate,
                        LessonId: student.LessonId,
                        Notes: student.Notes,
                        StartTime: student.StartTime,
                        StudentEmailId: student.StudentEmailId,
                        StudentName: student.StudentName,
                      };
                    });
                    this.setState({
                      checkedRecordsMode: [],
                      checkedRecords: chkRecords,
                    });
                  } else {
                    this.setState({ checkedRecords: [] });
                  }
                }}
                styles={{
                  // marginTop: this.state.checkedRecords.length ? "3px" : "0px",
                  marginTop: "0px",
                }}
              />
              <Label
                style={{ color: "#252423" }}
                iconPosition="start"
                icon={
                  <AttendeeIcon outline size="16" style={{ width: "16px" }} />
                }
                content={
                  <Text
                    content={t("attendance").body.headers.students}
                    size="medium"
                    weight="semibold"
                    style={{ marginLeft: "4px" }}
                    className="stud-name-lable"
                  />
                }
                color="white"
              />
              {this.state.checkedRecords.length ? (
                <Flex style={{ alignItems: "center" }} gap="gap.small">
                  <Button
                    circular
                    icon={<AcceptIcon />}
                    primary
                    title="Present"
                    style={{ ...styles.present, marginLeft: "10px" }}
                    onClick={() => {
                      this.checkedRecordsHandler(
                        "Presente",
                        this.props.user.username
                      );
                    }}
                  />
                  <Button
                    circular
                    icon={<CloseIcon />}
                    primary
                    title="Absent"
                    style={{ ...styles.absent, marginLeft: "10px" }}
                    onClick={() => {
                      this.checkedRecordsHandler(
                        "Ausente",
                        this.props.user.username
                      );
                    }}
                  />
                  <Button
                    circular
                    icon={<ShiftActivityIcon />}
                    primary
                    title="Late"
                    style={{ ...styles.late, marginLeft: "10px" }}
                    onClick={() => {
                      this.checkedRecordsHandler(
                        "Retardo",
                        this.props.user.username
                      );
                    }}
                  />
                </Flex>
              ) : //  this.state.checkedRecordsMode.length ? (
              //   <Flex style={{ alignItems: "center" }}>
              //     {/* <Icon.Home size="18" />
              //     <Icon.Home size="18" color="grey" /> */}
              //     <Button
              //       circular
              //       icon={<Icon.Monitor />}
              //       primary
              //       title={t("attendance").controls.classType[2]}
              //       style={{ ...styles.home, marginLeft: "10px" }}
              //       onClick={() => {
              //         this.checkedRecordsModeHandler({
              //           lessonId: this.state.checkedRecordsMode[0].LessonId,
              //           studentId: this.state.checkedRecordsMode.map(
              //             (data) => data.StudentEmailId
              //           ),
              //           mode: "Virtual",
              //         });
              //       }}
              //     />
              //     <Button
              //       circular
              //       icon={<Icon.Home />}
              //       primary
              //       title={t("attendance").controls.classType[1]}
              //       style={{
              //         backgroundColor: "white",
              //         color: "black",
              //         marginLeft: "10px",
              //       }}
              //       onClick={() => {
              //         this.checkedRecordsModeHandler({
              //           lessonId: this.state.checkedRecordsMode[0].LessonId,
              //           studentId: this.state.checkedRecordsMode.map(
              //             (data) => data.StudentEmailId
              //           ),
              //           mode: "Physical",
              //         });
              //       }}
              //     />
              //   </Flex>
              // )
              null}
              <DownloadIcon
                showExport={true}
                state={{
                  ...this.state,
                  ...{ accessToken: this.props.user.accessToken },
                }}
              />
            </Flex>
          ),
          key: "StudentsName",
        },
        {
          content: (
            <Flex>
              <Label
                style={{ color: "#252423" }}
                iconPosition="start"
                icon={<SurveyIcon outline />}
                content={
                  <Text
                    content={t("attendance").body.headers.attendance}
                    size="medium"
                    weight="semibold"
                    style={{ marginLeft: "4px" }}
                  />
                }
                color="white"
                styles={{ marginTop: "2px" }}
              />
            </Flex>
          ),
          key: "Attendance",
        },
        {
          content: (
            <Label
              style={{ color: "#252423" }}
              iconPosition="start"
              icon={<NotesIcon outline />}
              content={
                <Text
                  content={t("attendance").body.headers.notes}
                  size="medium"
                  weight="semibold"
                  style={{ marginLeft: "4px" }}
                />
              }
              color="white"
              className="action-notes"
              styles={{ marginTop: "2px" }}
            />
          ),
          key: "Note",
        },
        user?.role?.toLowerCase() === "teacher"
          ? {
              className: "student-progress-column",
              content: (
                <Label
                  style={{ color: "#252423" }}
                  iconPosition="start"
                  icon={<ContactCardIcon outline />}
                  content={
                    <Text
                      content={t("attendance").controls.progress}
                      size="medium"
                      weight="semibold"
                      style={{ marginLeft: "4px" }}
                    />
                  }
                  color="white"
                  className="action-notes"
                  styles={{ padding: "2px 0 0 2px" }}
                />
              ),
              key: "Progress",
            }
          : null,
      ],
    };

    // let studentPhotos = this.state.studentphotos.length
    //   ? [...this.state.studentphotos]
    //   : [];

    const rows = this.state.showRecords.map((student) => {
      // const rows = this.state.records.map((student) => {
      if (this.props.user.username !== student.StudentEmailId) {
        // console.log(student.StudentEmailId);

        // let lastImgUrl = studentPhotos.find(
        //   (studentInfo) => studentInfo.StudentEmailId === student.StudentEmailId
        // );
        return {
          key: `${student.StudentEmailId}  ${student.LessonId}`,
          className: student.ClassType === "Virtual" ? "bgVirtual" : "",
          items: [
            {
              content: (
                <Flex
                  hAlign="center"
                  vAlign="center"
                  style={{ justifyContent: "flex-start" }}
                >
                  <MenuButton
                    trigger={
                      <Flex
                        vAlign="center"
                        hAlign="center"
                        onClick={() => this.handleIconClick(student)}
                      >
                        <HomeOutlined
                          htmlColor={
                            student.ClassType === "Virtual"
                              ? "#7ddb7d"
                              : "#b1b4b1"
                          }
                        />
                      </Flex>
                    }
                    menu={[
                      {
                        content: !student?.StudentData?.isVirtual ? (
                          <ThumbtackIcon outline style={{ color: "#13c990" }} />
                        ) : (
                          <ThumbtackIcon style={{ color: "#13c990" }} />
                        ),
                        key: "pinned-" + student.StudentEmailId,
                        onClick: () => {
                          let data = [...this.state.showRecords];
                          data[data.indexOf(student)].ClassType = student
                            ?.StudentData?.isVirtual
                            ? "Hybrid"
                            : "Virtual";
                          data[data.indexOf(student)].StudentData.isVirtual =
                            !student?.StudentData?.isVirtual;
                          this.setState({ showRecords: data });
                          this.pinnedHandler(
                            student?.StudentData?.isVirtual,
                            student.StudentEmailId
                          );
                        },
                      },
                    ]}
                    unstable_pinned={false}
                    position="after"
                    align="top"
                    mouseLeaveDelay={0}
                    on="hover"
                    className="mode-control"
                  />
                  <Checkbox
                    checked={
                      this.state.checkedRecords.find(
                        (stud) =>
                          stud.StudentEmailId === student.StudentEmailId &&
                          String(stud.LessonId) === String(student.LessonId)
                      )
                        ? true
                        : false
                    }
                    onChange={(e, { checked }) => {
                      if (checked) {
                        let chkRecords = [...this.state.checkedRecords];
                        chkRecords.push({
                          Attendance: student.Attendance,
                          AttendanceTakenBy: student.AttendanceTakenBy,
                          ClassId: student.ClassId,
                          ClassName: student.ClassName,
                          EndTime: student.EndTime,
                          LessonDate: student.LessonDate,
                          LessonId: student.LessonId,
                          Notes: student.Notes,
                          StartTime: student.StartTime,
                          StudentEmailId: student.StudentEmailId,
                          StudentName: student.StudentName,
                        });
                        this.setState({
                          checkedRecords: chkRecords,
                        });
                      } else {
                        let chkRecords = [...this.state.checkedRecords];
                        let index = chkRecords.findIndex(
                          (stud) =>
                            stud.StudentEmailId === student.StudentEmailId &&
                            String(stud.LessonId) === String(student.LessonId)
                        );
                        if (index > -1) {
                          chkRecords.splice(index, 1);
                        }
                        this.setState({ checkedRecords: chkRecords });
                      }
                    }}
                  />

                  <ItemLayout
                    media={
                      <Avatar
                        // image={lastImgUrl ? lastImgUrl.Foto : null}
                        image={
                          student.StudentPhoto?.Foto
                            ? this.props.user.slug === "?slug=acvpreprod" ||
                              this.props.user.slug === "?slug=acvapp"
                              ? student.StudentPhoto.Foto
                              : student.StudentPhoto.Foto +
                                this.props.user.SASToken
                            : null || null
                        } //uncomment for security
                        // image={student.StudentPhoto?.Foto || null}
                        name={student.StudentName}
                        // size={document.documentElement.clientWidth<1060?"large":"medium"}
                      />
                    }
                    header={student.StudentName}
                    style={{ paddingLeft: "0px" }}
                    className="stud-name"
                  />
                </Flex>
              ),
              key: "1-1",
            },
            {
              content: (
                <Flex
                  gap="gap.small"
                  hAlign="center"
                  vAlign="center"
                  style={{ height: "50px" }}
                >
                  {student.Attendance === "Presente" ? (
                    <>
                      <Button
                        circular
                        icon={<AcceptIcon />}
                        primary
                        title={t("attendance").controls.present}
                        style={styles.present}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "NULL",
                            "NULL"
                          );
                        }}
                      />
                      <Button
                        text
                        content={t("attendance").controls.present}
                        style={styles.btnPresent}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "NULL",
                            "NULL"
                          );
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        circular
                        icon={<AcceptIcon />}
                        title={t("attendance").controls.present}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "Presente",
                            this.props.user.username
                          );
                        }}
                      />
                      <Button
                        text
                        content={t("attendance").controls.present}
                        style={styles.btnPresent}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "Presente",
                            this.props.user.username
                          );
                        }}
                      />
                    </>
                  )}
                  {/* {student.Attendance==="Ausente" || student.JustifyReason!=null? */}
                  {/* BELOW LINE SHOULD BE LIKE ABOVE */}
                  {student.Attendance === "Ausente" ||
                  student.Attendance === "Sickness" ||
                  student.Attendance === "Family emergency" ||
                  student.Attendance === "Not feel well" ? (
                    <>
                      <MenuButton
                        trigger={
                          <Button
                            circular
                            icon={<CloseIcon />}
                            primary
                            title={t("attendance").controls.absent}
                            style={
                              student.Attendance !== "Ausente"
                                ? styles.justify
                                : styles.absent
                            }
                            onClick={() => {
                              this.takeAttendance(
                                student.StudentEmailId,
                                student.LessonId,
                                "NULL",
                                "NULL"
                              );
                            }}
                          />
                        }
                        menu={[
                          student.Attendance === "Sickness" ? (
                            <Label
                              key={"Lable-1-" + student.StudentEmailId}
                              content={t("attendance").controls.reasons[0]}
                              color="brand"
                              onClick={() =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "NULL",
                                  this.props.user.username
                                )
                              }
                            />
                          ) : (
                            {
                              content: t("attendance").controls.reasons[0],
                              key: "Lable-11-" + student.StudentEmailId,
                              onClick: () =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "Sickness",
                                  this.props.user.username
                                ),
                            }
                          ),
                          student.Attendance === "Family emergency" ? (
                            <Label
                              key={"Lable-2-" + student.StudentEmailId}
                              content={t("attendance").controls.reasons[1]}
                              color="brand"
                              onClick={() =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "NULL",
                                  this.props.user.username
                                )
                              }
                            />
                          ) : (
                            {
                              content: t("attendance").controls.reasons[1],
                              key: "Lable-22-" + student.StudentEmailId,
                              onClick: () =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "Family emergency",
                                  this.props.user.username
                                ),
                            }
                          ),
                          student.Attendance === "Not feel well" ? (
                            <Label
                              key={"Lable-3-" + student.StudentEmailId}
                              content={t("attendance").controls.reasons[2]}
                              color="brand"
                              onClick={() =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "NULL",
                                  this.props.user.username
                                )
                              }
                            />
                          ) : (
                            {
                              content: t("attendance").controls.reasons[2],
                              key: "Lable-33-" + student.StudentEmailId,
                              onClick: () =>
                                this.takeAttendance(
                                  student.StudentEmailId,
                                  student.LessonId,
                                  "Not feel well",
                                  this.props.user.username
                                ),
                            }
                          ),
                        ]}
                        //////////////////////////////////////////////
                        unstable_pinned={false}
                        position="after"
                        align="top"
                        mouseLeaveDelay={0}
                        //////////////////////////////////////////////
                        on="hover"
                      />
                      <Button
                        text
                        content={t("attendance").controls.absent}
                        style={styles.btnAbsent}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "NULL",
                            "NULL"
                          );
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <MenuButton
                        trigger={
                          <Button
                            circular
                            icon={<CloseIcon />}
                            title={t("attendance").controls.absent}
                            style={{ marginLeft: "-10px" }}
                            onClick={() => {
                              this.takeAttendance(
                                student.StudentEmailId,
                                student.LessonId,
                                "Ausente",
                                this.props.user.username
                              );
                            }}
                          />
                        }
                        menu={[
                          {
                            content: t("attendance").controls.reasons[0],
                            key: "Lable-11-" + student.StudentEmailId,
                            onClick: () =>
                              this.takeAttendance(
                                student.StudentEmailId,
                                student.LessonId,
                                "Sickness",
                                this.props.user.username
                              ),
                          },
                          {
                            content: t("attendance").controls.reasons[1],
                            key: "Lable-22-" + student.StudentEmailId,
                            onClick: () =>
                              this.takeAttendance(
                                student.StudentEmailId,
                                student.LessonId,
                                "Family emergency",
                                this.props.user.username
                              ),
                          },
                          {
                            content: t("attendance").controls.reasons[2],
                            key: "Lable-33-" + student.StudentEmailId,
                            onClick: () =>
                              this.takeAttendance(
                                student.StudentEmailId,
                                student.LessonId,
                                "Not feel well",
                                this.props.user.username
                              ),
                          },
                        ]}
                        ////////////////////////////////////
                        unstable_pinned={false}
                        position="after"
                        align="top"
                        mouseLeaveDelay={0}
                        ////////////////////////////////
                        on="hover"
                      />
                      <Button
                        text
                        content={t("attendance").controls.absent}
                        style={styles.btnAbsent}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "Ausente",
                            this.props.user.username
                          );
                        }}
                      />
                    </>
                  )}
                  {student.Attendance === "Retardo" ? (
                    <>
                      <Button
                        circular
                        icon={<ShiftActivityIcon />}
                        primary
                        title={t("attendance").controls.late}
                        style={styles.late}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "NULL",
                            "NULL"
                          );
                        }}
                      />
                      <Button
                        text
                        content={t("attendance").controls.late}
                        style={styles.btnLate}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "NULL",
                            "NULL"
                          );
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        circular
                        icon={<ShiftActivityIcon />}
                        title={t("attendance").controls.late}
                        style={{ marginLeft: "-10px" }}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "Retardo",
                            this.props.user.username
                          );
                        }}
                      />
                      <Button
                        text
                        content={t("attendance").controls.late}
                        style={styles.btnLate}
                        onClick={() => {
                          this.takeAttendance(
                            student.StudentEmailId,
                            student.LessonId,
                            "Retardo",
                            this.props.user.username
                          );
                        }}
                      />
                    </>
                  )}
                  {/* {student.ClassType !== "Physical" ? (
                    <>
                      <Button
                        circular
                        icon={<Icon.Monitor />}
                        title="Physical"
                        style={styles.home}
                        onClick={() => {
                          this.checkedRecordsModeHandler({
                            lessonId: student.LessonId,
                            studentId: [student.StudentEmailId],
                            mode: "Physical",
                          });
                        }}
                      />
                      <Button
                        text
                        content="Virtual"
                        style={styles.btnHome}
                        onClick={() => {
                          this.checkedRecordsModeHandler({
                            lessonId: student.LessonId,
                            studentId: [student.StudentEmailId],
                            mode: "Physical",
                          });
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        circular
                        icon={<Icon.Monitor />}
                        title="Virtual"
                        style={{ marginLeft: "-10px" }}
                        onClick={() => {
                          this.checkedRecordsModeHandler({
                            lessonId: student.LessonId,
                            studentId: [student.StudentEmailId],
                            mode: "Virtual",
                          });
                        }}
                      />
                      <Button
                        text
                        content="Virtual"
                        brand
                        style={styles.btnLate}
                        onClick={() => {
                          this.checkedRecordsModeHandler({
                            lessonId: student.LessonId,
                            studentId: [student.StudentEmailId],
                            mode: "Virtual",
                          });
                        }}
                      />
                    </>
                  )} */}
                </Flex>
              ),
              key: "1-2",
            },
            {
              content: (
                <Flex
                  gap="gap.large"
                  hAlign="center"
                  vAlign="center"
                  style={{ height: "50px" }}
                >
                  <Flex.Item size="size.flex">
                    <Input
                      className="note-input"
                      placeholder="Notes"
                      value={
                        student.Notes === null || student.Notes === "NULL"
                          ? ""
                          : student.Notes || ""
                      }
                      onChange={(e) => {
                        // Update local state immediately for responsive UI
                        const updatedStudents = [...this.state.showRecords];
                        const studentIndex = updatedStudents.findIndex(
                          (s) =>
                            s.StudentEmailId === student.StudentEmailId &&
                            s.LessonId === student.LessonId
                        );
                        if (studentIndex !== -1) {
                          updatedStudents[studentIndex].Notes = e.target.value;
                          this.setState({ showRecords: updatedStudents });
                        }
                      }}
                      onBlur={(e) => {
                        this.studentNoteHandler(
                          student.StudentEmailId,
                          student.LessonId,
                          e.target.value
                        );
                      }}
                      fluid
                    />
                  </Flex.Item>
                  {/* <Flex.Item size="size.quarter">
                    <Button
                      tabIndex={-1}
                      icon={<MoreIcon />}
                      circular
                      text
                      iconOnly
                      title="More options"
                    />
                  </Flex.Item> */}
                </Flex>
              ),
              key: "1-3",
            },
            ["teacher", "superadmin"].includes(user?.role?.toLowerCase())
              ? {
                  className: "student-progress-column",
                  content: (
                    <Flex gap="gap.large">
                      <Flex.Item size="size.flex">
                        <StudentProgress
                          {...this.props}
                          triggerButton={(clickHandler) => (
                            <Button
                              icon={<TranscriptIcon outline />}
                              iconOnly
                              onClick={() => clickHandler(student)}
                            />
                          )}
                          headerText={`${student.StudentName} ${
                            t("attendance").controls.progressData
                          }`}
                        />
                      </Flex.Item>
                    </Flex>
                  ),
                  key: "1-4",
                }
              : null,
          ],
        };
      } else {
        return null;
      }
    });

    const showTopicHandler = () => {
      this.handleResize("TOPIC");
      // this.setState({ showTopic: !this.state.showTopic });
    };

    const showNoteHandler = () => {
      this.handleResize("NOTE");
      // this.setState({ showNote: !this.state.showNote });
    };

    const convertUtcToLocalTime = (utcDate, utcTime) => {
      return moment.utc(`${utcDate} ${utcTime}`).local().format("HH:mm");
    };

    const myCard = (lsn) => {
      const TextWithTooltip = ({ lsn }) => {
        const classPart1 = lsn.ClassName.split("-")[1];
        const classPart2 = lsn.ClassName.split("-")[2];
        const tooltipText = `${classPart1} - ${classPart2}`;

        // Detect mobile device
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (isMobile) {
          // 🟢 MOBILE → use Popup (click trigger)
          const handleClick = (e) => {
            e.stopPropagation(); // prevent parent card click
          };

          return (
            <Popup
              content={tooltipText}
              trigger={
                <div onClick={handleClick}>
                  <Text
                    content={tooltipText}
                    data-text={tooltipText}
                    size="small"
                    style={styles.hideText}
                  />
                </div>
              }
              on="click"
              position="above"
              align="center"
            />
          );
        } else {
          // 🟣 DESKTOP → use Tooltip (hover trigger)
          return (
            <Tooltip
              content={tooltipText}
              trigger={
                <Text
                  content={tooltipText}
                  data-text={tooltipText}
                  size="small"
                  style={styles.hideText}
                />
              }
            />
          );
        }
      };
      let date = moment.utc(`${lsn.LessonDate}`).local().format("YYYY-MM-DD");

      const localStartTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.StartTime
      );
      const localEndTime = convertUtcToLocalTime(
        moment(lsn.LessonDate).format("YYYY-MM-DD"),
        lsn.EndTime
      );

      const cardToolTip = `${localStartTime + " - " + localEndTime}   ${date}
      <br />${lsn.ClassName.split(" - ")[0]}<br />${
        lsn.ClassName.split(" - ")[1]
      }`;
      // Use a stable DOM key; prefer LessonId, otherwise composite fallback
      const lessonKey = this.getLessonDomKey(lsn);

      return (
        <Card
          key={lessonKey}
          data-lesson-id={lessonKey}
          style={{
            marginBottom: "10px",
            borderRadius: "7px",
            cursor: "pointer",
            border: "2px solid #d3d3d314",
            width: "auto",
          }}
          className={
            this.state.selectedLesson &&
            this.getLessonDomKey(this.state.selectedLesson) === lessonKey
              ? "selectedCard"
              : "card"
          }
          compact
          horizontal
          aria-roledescription="ACV - Asistente de clases virtuales | Tangible IT"
          onClick={async () => {
            this.dismissPanel();
            if (!document.querySelector(".Attendance.h-cls")) {
              document.querySelector(".Attendance").classList.add("h-cls");
            }
            if (this.state.showTopic !== true && this.state.showNote !== true) {
              // Track lesson change for undo/redo
              try {
                const prevLesson = this.state.selectedLesson;
                const nextLesson = lsn;
                // Skip push when this is a programmatic click initiated by voice selection
                if (this.isProgrammaticLessonClick) {
                } else if (!this.isPerformingUndo && nextLesson) {
                  const { showLesson } = this.state;
                  this._pushUndoAction({
                    type: "lesson",
                    previous: prevLesson ? prevLesson.LessonId : null,
                    next: nextLesson ? nextLesson.LessonId : null,
                    previousKey: prevLesson
                      ? this.getLessonDomKey(prevLesson)
                      : null,
                    nextKey: nextLesson
                      ? this.getLessonDomKey(nextLesson)
                      : null,
                    previousSnapshot: prevLesson
                      ? this.buildLessonSnapshot(prevLesson)
                      : null,
                    nextSnapshot: nextLesson
                      ? this.buildLessonSnapshot(nextLesson)
                      : null,
                    previousIndex: prevLesson
                      ? this.findLessonIndex(prevLesson, showLesson)
                      : -1,
                    nextIndex: nextLesson
                      ? this.findLessonIndex(nextLesson, showLesson)
                      : -1,
                  });
                }
              } catch (e) {}
              this.setState({
                load: true,
                checkedRecords: [],
                checkedRecordsMode: [],
                selectedLesson: await lsn,
              });
              this.fetchRecordsByLesson();
              // Sync inputs with the clicked lesson data directly to avoid stale state reads
              const topicEl = document.getElementById("textLessonTopic");
              const noteEl = document.getElementById("textLessonNote");
              if (topicEl) topicEl.value = lsn.Tema || "";
              if (noteEl) noteEl.value = lsn.Tarea || "";
            } else {
              // console.log("Please Handel opened window first!");
            }
          }}
        >
          {this.state.isCompactMode && (
            <ReactTooltip
              place="right"
              type="light"
              effect="float"
              multiline={true}
            />
          )}
          <Card.Preview
            horizontal
            data-tip={cardToolTip}
            styles={{ marginRight: "7.925px" }}
          >
            <Image
              style={styles.cardImg}
              // src={
              // lsn.ClassName.includes("Art")
              //   ? Imgart
              //   : lsn.ClassName.includes("Civismo")
              //   ? Imgcivil
              //   : lsn.ClassName.includes("Hist")
              //   ? Imghistory
              //   : lsn.ClassName.includes("Science")
              //   ? ImgnaturalScience
              //   : lsn.ClassName.includes("losof")
              //   ? Imgphilosophy
              //   : lsn.ClassName.includes("Ciencias Exactas")
              //   ? ImgscienceExact
              //   : lsn.ClassName.includes("Tec")
              //   ? Imgtech
              //   : Imgother
              // }
              src={
                lsn?.LessionData
                  ? lsn?.LessionData.lessonImage?.ImageURL
                    ? lsn.LessionData.lessonImage.ImageURL +
                      this.props?.user?.SASToken
                    : lsn.ClassName.includes("Art")
                    ? Imgart
                    : lsn.ClassName.includes("Civismo")
                    ? Imgcivil
                    : lsn.ClassName.includes("Hist")
                    ? Imghistory
                    : lsn.ClassName.includes("Science")
                    ? ImgnaturalScience
                    : lsn.ClassName.includes("losof")
                    ? Imgphilosophy
                    : lsn.ClassName.includes("Ciencias Exactas")
                    ? ImgscienceExact
                    : lsn.ClassName.includes("Tec")
                    ? Imgtech
                    : Imgother
                  : lsn?.lessonImage?.ImageURL
                  ? lsn.lessonImage.ImageURL + this.props?.user?.SASToken
                  : lsn.ClassName.includes("Art")
                  ? Imgart
                  : lsn.ClassName.includes("Civismo")
                  ? Imgcivil
                  : lsn.ClassName.includes("Hist")
                  ? Imghistory
                  : lsn.ClassName.includes("Science")
                  ? ImgnaturalScience
                  : lsn.ClassName.includes("losof")
                  ? Imgphilosophy
                  : lsn.ClassName.includes("Ciencias Exactas")
                  ? ImgscienceExact
                  : lsn.ClassName.includes("Tec")
                  ? Imgtech
                  : Imgother
              }
            />
          </Card.Preview>

          <Card.Column className={isCompactMode ? "d-none" : ""}>
            <Card.Header>
              <Flex gap="gap.small">
                <Text
                  content={localStartTime + " - " + localEndTime}
                  size="small"
                  style={{ marginTop: "6px" }}
                />
                <Text
                  content={
                    this.state.isDateSelected
                      ? moment.utc(lsn.LessonDate).local().format("YYYY-MM-DD")
                      : moment(new Date()).format("YYYY-MM-DD")
                  }
                  size="small"
                  style={{ marginTop: "6px" }}
                />
              </Flex>
              <Text
                content={lsn.ClassName.split("-")[0]}
                weight="semibold"
                style={styles.hideText}
              />

              <TextWithTooltip lsn={lsn} />
            </Card.Header>
          </Card.Column>
        </Card>
      );
    };

    return (
      <div className="Attendance s-ctr">
        {this.props?.user?.actualRole === "SuperAdmin" ? (
          <Dialog
            open={this.state.dialog}
            onConfirm={() => this.setState({ dialog: false })}
            confirmButton="Okay"
            content={
              "Your Plan will expire on " +
              (this.state.ExpirationDate
                ? moment(this.state.ExpirationDate).format("MMMM D, YYYY")
                : "-") +
              ". Request for renewal ASAP!"
            }
            header="Your ACV Plan"
            headerAction={{
              icon: <CloseIcon />,
              title: "Close",
              onClick: () => this.setState({ dialog: false }),
            }}
          />
        ) : null}
        <Dialog
          open={this.state.accDlg}
          onConfirm={() => location.reload()}
          confirmButton="Refresh Now"
          content={
            <p className="refreshMsg">
              No big deal — but we need to refresh to show your content.
            </p>
          }
          header="Authorization expire"
        />
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
        >
          {!this.state.isExpire && this.state.isSubscribed && (
            <Controls
              isCompactMode={isCompactMode}
              myCard={myCard}
              state={{
                ...this.state,
                ...{ accessToken: this.props.user.accessToken },
              }}
              user={this.props.user}
              labels={t("attendance").controls}
              cLabels={t("AttendanceHistory").controls}
              onDateDataChange={async (date) => {
                this.setState({
                  selectedDate: await date,
                  isDateSelected: true,
                  getSelectedData: date,
                });
                this.fetchLessons();
              }}
              showExport={true}
              showTopic={
                this.state.selectedLesson ? showTopicHandler.bind() : null
              }
              showNote={
                this.state.selectedLesson ? showNoteHandler.bind() : null
              }
              changeLsnByClass={async (e) => {
                this.setState({ selectedClass: await e });
                this.fetchLessons();
              }}
              changeLsnByTeacher={async (e) => {
                this.setState({ selectedTeacher: await e });
                this.fetchLessons();
              }}
              resetSelected={() => {
                this.setState(
                  {
                    selectedClass: null,
                    selectedTeacher: null,
                  },
                  () => this.fetchLessons()
                );
              }}
              fetchRcrd={() => this.fetchRecordsByLesson()}
              page="attendance"
              isLessonsAvailable={!!this.state.showLesson?.length}
              handleClose={this.handleClose}
              open={this.props.isMobileViewFiltersOpen}
              isOpen={this.state.isOpen}
              openPanel={this.openPanel}
              dismissPanel={this.dismissPanel}
            />
          )}
        </div>
        <div
          style={{
            width: "100%",
            overflow: "auto",
            backgroundColor: "white",
          }}
        >
          <Flex gap="gap.medium" wrap className="container2">
            {this.state.isSubscribed &&
            this.state.showLesson &&
            this.state.showLesson.length &&
            !this.state.isExpire ? (
              <Flex
                gap="gap.medium"
                className={`tour-select-lesson ${
                  isCompactMode ? "availableClass mr-0" : "availableClass"
                }`}
              >
                {(this.props.user.slug === "?slug=acvpreprod" ||
                  this.props.user.slug === "?slug=acvapp") &&
                (this.state.selectedDay === "Sunday" ||
                  this.state.selectedDay === "Saturday") ? null : (
                  <>
                    <div
                      // className="d-none"
                      style={{
                        // ------------- nice feel -----------
                        // padding: 17px 0px 9px 8px;
                        // width: 307px;
                        // margin-left: 37px;
                        // border-bottom: 1px solid #d6d6d6;
                        // background: transparent;
                        // -----------------------------------
                        paddingTop: "18px",
                        width: isCompactMode ? "auto" : "100%",
                        paddingLeft: "40px",
                        marginRight: "0px",
                      }}
                    >
                      <Label
                        style={{ color: "#252423", cursor: "pointer" }}
                        iconPosition="start"
                        icon={
                          isCompactMode ? <IndentIcon /> : <NumberListIcon />
                        }
                        content={
                          isCompactMode ? (
                            ""
                          ) : (
                            <Text
                              content={t("attendance").body.lessions}
                              size="medium"
                              weight="semibold"
                              style={{ marginLeft: "4px" }}
                            />
                          )
                        }
                        color="white"
                        onClick={() => this.onCompactModeHandler()}
                      />
                    </div>
                    <AvailbleClass
                      isCompactMode={isCompactMode}
                      state={this.state}
                      myCard={myCard}
                    />
                  </>
                )}
              </Flex>
            ) : null}
            {(!this.state.isSubscribed && !this.state.load) ||
            this.state.isExpire ? (
              <Subscription
                pageName="attendance"
                isExpire={this.state.isExpire}
                role={this.props.user.role}
              />
            ) : (
              <Flex gap="gap.medium" wrap>
                <div
                  className={`${
                    this.state.showRecords?.length
                      ? "tour-attendence-students"
                      : ""
                  } ${[
                    !this.state.selectedTeacher &&
                    !this.state.selectedClass &&
                    !this.state.showLesson?.length
                      ? "table-wrapper w-100"
                      : "table-wrapper",
                    isCompactMode ? "table-wrapper-w-100" : "",
                  ].join(" ")}`}
                >
                  {this.state.load ? (
                    // <Loader size="medium" style={{ paddingTop: "50px" }} />
                    <AttendanceSkeleton />
                  ) : rows.length ? (
                    <>
                      {/* <Drawer
                        isCompactMode={isCompactMode}
                        state={this.state}
                        myCard={myCard}
                      /> */}
                      <Table
                        header={header}
                        aria-label="Student Data"
                        style={{ position: "relative" }}
                      />
                      <Table
                        rows={rows}
                        className="attendance-data-table"
                        aria-label="Student Data"
                        style={{ position: "relative" }}
                      />
                    </>
                  ) : !this.state.selectedClass &&
                    !this.state.showLesson?.length ? (
                    <>
                      <h1 style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                        {t("attendance").body.noclass}
                      </h1>
                      <figure className="w-100">
                        <img
                          alt="ACV - Tangible IT"
                          src={DateSelection}
                          style={{
                            maxWidth: "35%",
                            width: "fit-content",
                          }}
                          draggable="false"
                        />
                      </figure>
                    </>
                  ) : !this.state.selectedClass ? (
                    <figure
                      className="class-figure-image w-100 d-md-center d-sm-start"
                      style={{
                        display: "flex",
                        height: "100%",
                        margin: "auto",
                      }}
                    >
                      <img
                        alt="ACV - Tangible IT"
                        src={LessonSelection}
                        style={{
                          maxWidth: "50%",
                        }}
                        draggable="false"
                      />
                    </figure>
                  ) : (
                    ""
                  )}
                </div>
              </Flex>
            )}
          </Flex>
        </div>

        {this.state.isMobileView ? (
          <div
            style={{
              display: this.state.showTopic ? "block" : "none",
              position: "absolute",
              boxShadow:
                "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
              minHeight: "100%",
              width: "100%",
              background: "white",
              borderradius: "5px",
              zIndex: "2",
            }}
          >
            <div
              style={{
                height: "50px",
                width: this.state.isSmall ? 0 : "340px",
                left: "10px",
                top: "0px",
                borderRadius: "0px",
                position: "absolute",
                right: "76.6%",
                bottom: "29.14%",
              }}
            >
              <h3
                style={{
                  position: "absolute",
                  width: "235px",
                  height: "24px",
                  left: "20px",
                  top: "32px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "24px",
                  color: "#252525",
                }}
              >
                {t("attendance").controls.topic[1]}
              </h3>
            </div>
            <textarea
              style={{
                position: "absolute",
                bottom: "10%",
                background: "rgb(241, 241, 241)",
                height: "50%",
                width: this.state.isSmall ? "82%" : "86%",
                left: "28px",
                top: "11%",
                borderRadius: "4px",
                border: "none",
                padding: "14px",
                fontSize: "15px",
                outline: "none",
                resize: "none",
              }}
              id="textLessonTopic"
              rows="4"
              cols="50"
              placeholder={t("attendance").controls.startTyping}
              onBlur={(e) => {
                const topic = { ...this.state.selectedLesson };
                topic.Tema = e.target.value;
                this.setState({ selectedLesson: topic });
              }}
            ></textarea>
            <div
              style={{
                position: "absolute",
                right: "23px",
                bottom: "1.43%",
                height: "60px",
                width: !this.state.isSmall && "311px",
                left: "64px",
                top: "420px",
              }}
            >
              <Button
                content={t("attendance").controls.cancel}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "128px",
                }}
                // tinted="true"
                onClick={() => this.setState({ showTopic: false })}
              />
              <Button
                content={t("attendance").controls.save}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "23px",
                }}
                primary
                onClick={() => {
                  this.lessonTopicHandler();
                }}
              />
            </div>
          </div>
        ) : (
          <div style={styles.topic}>
            <div
              style={{
                height: "50px",
                width: this.state.isSmall ? 0 : "340px",
                left: "10px",
                top: "0px",
                borderRadius: "0px",
                position: "absolute",
                right: "76.6%",
                bottom: "29.14%",
              }}
            >
              <h3
                style={{
                  position: "absolute",
                  width: "235px",
                  height: "24px",
                  left: "31px",
                  top: "7px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "24px",
                  color: "#252525",
                }}
              >
                {t("attendance").controls.topic[1]}
              </h3>
            </div>
            <textarea
              style={{
                position: "absolute",
                bottom: "10%",
                background: "rgb(241, 241, 241)",
                height: "144px",
                width: this.state.isSmall ? "82%" : "284px",
                left: "28px",
                top: "57px",
                borderRadius: "4px",
                border: "none",
                padding: "14px",
                fontSize: "15px",
                outline: "none",
                resize: "none",
              }}
              id="textLessonTopic"
              rows="4"
              cols="50"
              placeholder={t("attendance").controls.startTyping}
              onBlur={(e) => {
                const topic = { ...this.state.selectedLesson };
                topic.Tema = e.target.value;
                this.setState({ selectedLesson: topic });
              }}
            ></textarea>
            <div
              style={{
                position: "absolute",
                right: "23px",
                bottom: "1.43%",
                height: "60px",
                width: !this.state.isSmall && "311px",
                left: "23px",
                top: "210px",
              }}
            >
              <Button
                content={t("attendance").controls.cancel}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "128px",
                }}
                // tinted="true"
                onClick={() => this.setState({ showTopic: false })}
              />
              <Button
                content={t("attendance").controls.save}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "23px",
                }}
                primary
                onClick={() => {
                  this.lessonTopicHandler();
                }}
              />
            </div>
          </div>
        )}

        {this.state.isMobileView ? (
          <div
            style={{
              display: this.state.showNote ? "block" : "none",
              position: "absolute",
              boxShadow:
                "rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px",
              minHeight: "100%",
              width: "100%",
              background: "white",
              borderradius: "5px",
              zIndex: "2",
            }}
          >
            <div
              style={{
                height: "50px",
                width: this.state.isSmall ? 0 : "340px",
                left: "10px",
                top: "0px",
                borderRadius: "0px",
                position: "absolute",
                bottom: "29.14%",
              }}
            >
              <h3
                style={{
                  position: "absolute",
                  width: "235px",
                  height: "24px",
                  left: "20px",
                  top: "32px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "24px",
                  color: "#252525",
                }}
              >
                {t("attendance").controls.homework[1]}
              </h3>
            </div>
            <textarea
              style={{
                position: "absolute",
                bottom: "10%",
                background: "rgb(241, 241, 241)",
                height: "50%",
                width: this.state.isSmall ? "82%" : "86%",
                left: "28px",
                top: "11%",
                borderRadius: "4px",
                border: "none",
                padding: "14px",
                fontSize: "15px",
                outline: "none",
                resize: "none",
              }}
              id="textLessonNote"
              rows="4"
              cols="50"
              placeholder={t("attendance").controls.startTyping}
              onBlur={(e) => {
                const lesson = { ...this.state.selectedLesson };
                lesson.Tarea = e.target.value;
                this.setState({ selectedLesson: lesson });
              }}
            ></textarea>
            <div
              style={{
                position: "absolute",
                right: "23px",
                bottom: "1.43%",
                height: "60px",
                width: !this.state.isSmall && "311px",
                left: "64px",
                top: "420px",
              }}
            >
              <Button
                content={t("attendance").controls.cancel}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "128px",
                }}
                // tinted="true"
                onClick={() => this.setState({ showNote: false })}
              />
              <Button
                content={t("attendance").controls.save}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "23px",
                }}
                primary
                onClick={() => {
                  this.lessonNoteHandler();
                }}
              />
            </div>
          </div>
        ) : (
          <div style={styles.notes}>
            <div
              style={{
                height: "50px",
                width: this.state.isSmall ? 0 : "340px",
                left: "10px",
                top: "0px",
                borderRadius: "0px",
                position: "absolute",
                bottom: "29.14%",
              }}
            >
              <h3
                style={{
                  position: "absolute",
                  width: "235px",
                  height: "24px",
                  left: "31px",
                  top: "7px",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "bold",
                  fontSize: "18px",
                  lineHeight: "24px",
                  color: "#252525",
                }}
              >
                {t("attendance").controls.homework[1]}
              </h3>
            </div>
            <textarea
              style={{
                position: "absolute",
                bottom: "10%",
                background: "rgb(241, 241, 241)",
                height: "144px",
                width: this.state.isSmall ? "82%" : "284px",
                left: "28px",
                top: "57px",
                borderRadius: "4px",
                border: "none",
                padding: "14px",
                fontSize: "15px",
                outline: "none",
                resize: "none",
              }}
              id="textLessonNote"
              rows="4"
              cols="50"
              placeholder={t("attendance").controls.startTyping}
              onBlur={(e) => {
                const lesson = { ...this.state.selectedLesson };
                lesson.Tarea = e.target.value;
                this.setState({ selectedLesson: lesson });
              }}
            ></textarea>
            <div
              style={{
                position: "absolute",
                right: "23px",
                bottom: "1.43%",
                height: "60px",
                width: !this.state.isSmall && "311px",
                left: "23px",
                top: "210px",
              }}
            >
              <Button
                content={t("attendance").controls.cancel}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "128px",
                }}
                // tinted="true"
                onClick={() => this.setState({ showNote: false })}
              />
              <Button
                content={t("attendance").controls.save}
                style={{
                  position: "absolute",
                  width: "96px",
                  height: "32px",
                  right: "23px",
                }}
                primary
                onClick={() => {
                  this.lessonNoteHandler();
                }}
              />
            </div>
          </div>
        )}

        {null}
      </div>
    );
  }
}
export default withTranslation()(Attendance);
